/* ADDITIONAL JAVASCRIPT HERE */

document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {

        //variables for preview section
        var selectedVariantId = $('input[name="Size"]:checked').val();
        console.log("Selected Variant ID: " + selectedVariantId);
        var fabricMain="";
        var bedhead="";
        var base="";
        var baseFeet="";
        var colorMain="";
        var fabric="";
        var adjustVal="";
        var exists = 0;
        var baseExists = 0;
        var headExists = 0;
        var caret='<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>';

        $('.bed-shipping > label').append(caret);
        $('.additional-options > label').append(caret);
        $('.build-ensemble > label').append(caret);
        $('.buy-adjustable .spb-label-tooltip > label').append(caret);      


        $('.build-ensemble > span').hide();
        $('.buy-adjustable > span').hide();
        $('.bed-shipping > span').hide();
        $('.additional-options > span').hide();

        $('.build-ensemble > label').on('click', function(e) {
          $('.build-ensemble').toggleClass("bed-collapsed");
          e.preventDefault();
        });
        $('.buy-adjustable .spb-label-tooltip > label').on('click', function(e) {
          $('.buy-adjustable').toggleClass("bed-collapsed");
          e.preventDefault();
        });
      
        $('.additional-options > label').on('click', function(e) {
          $('.additional-options').toggleClass("bed-collapsed");
          e.preventDefault();
        });
        $('.bed-shipping > label').on('click', function(e) {
          $('.bed-shipping').toggleClass("bed-collapsed");
          e.preventDefault();
        });      
        $('.bed-shipping').addClass("bed-collapsed");
        $('.preview-list').hide();

      
      
        $('.select-color .spb-productdesctextcolor:first-child').append('<a href="#" class="mattress-add-link" id="base-fabric-option" style="display:none;"> Preview fabric and colour.</a>');
      $('.select-color-haven .spb-productdesctextcolor:first-child').append('<a href="#" class="mattress-add-link" id="base-fabric-option" style="display:none;"> Preview fabric and colour.</a>');
      $('.select-color-plush .spb-productdesctextcolor:first-child').append('<a href="#" class="mattress-add-link" id="base-fabric-option" style="display:none;"> Preview fabric and colour.</a>');
        $('.base-type-option .spb-productdesctextcolor:first-child').append('<a href="#" class="mattress-add-link" id="base-type-option" style="display:none;"> Base type option reference here.</a>');
        $('.bed-head-type .spb-productdesctextcolor:first-child').append('<a href="#" class="mattress-add-link" id="bed-head-option" style="display:none;"> Bedhead type option reference here.</a>');
        $('.adjustable-option .spb-productdesctextcolor:first-child').append('<a href="#" class="mattress-add-link" id="adjustable-option"> Adjustable base options here.</a>');            
        //$('.base-feet-options .spb-productdesctextcolor:first-child').append('<a href="#" class="mattress-add-link" id="base-feet-option"> Base feet option reference here.</a>');

          $('.select-color span label').each(function(){
            $(this).click(function(){
              colorMain = $('input',this).val();
              console.log('Color MAIN:'+colorMain);
              filterOptions(selectedVariantId,colorMain); 
              $('.color-selected').html(colorMain);
              displayVariant(selectedVariantId,colorMain,fabricMain,base,bedhead);
              showbasePreview(fabricMain,colorMain,base);
              showheadPreview(fabricMain,colorMain,bedhead);
              generateList(fabricMain,colorMain,base,bedhead,baseFeet);
            });
          });
          $('.select-color-haven span label').each(function(){
            $(this).click(function(){
              colorMain = $('input',this).val();
              console.log('Color MAIN:'+colorMain);
              filterOptions(selectedVariantId,colorMain); 
              $('.color-selected').html(colorMain);
              displayVariant(selectedVariantId,colorMain,fabricMain,base,bedhead);
              showbasePreview(fabricMain,colorMain,base);
              showheadPreview(fabricMain,colorMain,bedhead);
              generateList(fabricMain,colorMain,base,bedhead,baseFeet);
            });
          });
          $('.select-color-plush span label').each(function(){
            $(this).click(function(){
              colorMain = $('input',this).val();
              console.log('Color MAIN:'+colorMain);
              filterOptions(selectedVariantId,colorMain); 
              $('.color-selected').html(colorMain);
              displayVariant(selectedVariantId,colorMain,fabricMain,base,bedhead);
              showbasePreview(fabricMain,colorMain,base);
              showheadPreview(fabricMain,colorMain,bedhead);
              generateList(fabricMain,colorMain,base,bedhead,baseFeet);
            });
          });               


          //fabric selection
          $('.base-fabric-choice .spb-productoptionswatchwrapper').each(function(){
            $(this).click(function(){
              fabric = $('input',this).val();
              console.log('FABRIC: '+fabric);
              showbasePreview(fabric,colorMain,base);
              showheadPreview(fabricMain,colorMain,bedhead);
              generateList(fabricMain,colorMain,base,bedhead,baseFeet);
              displayVariant(selectedVariantId,colorMain,fabricMain,base,bedhead);
            });
          });
          
          // MATTRESS ACTUAL SIZE CHANGE
          $('.template-product-mattress input[type="radio"][name="Size"]').on('change', function(event) {
            exists = 0;
            baseExists = 0;
            headExists = 0;            
            //event.stopPropagation();
            selectedVariantId = $('input[name="Size"]:checked').val();
            console.log("Selected Variant ID: " + selectedVariantId);
            filterOptions(selectedVariantId,colorMain);
            displayVariant(selectedVariantId,colorMain,fabricMain,base,bedhead);            
            generateList(fabricMain,colorMain,base,bedhead,baseFeet);
            adjustSelection(selectedVariantId);
          });    
      

      // BASE FABRIC UPDATE
      $('.base-fabric-choice .spb-helptext').appendTo('.base-fabric-choice #base_fabric_choice-0-3');
      $('.select-color .spb-helptext').appendTo('.select-color #select_your_fabric_colour_augustus-0-4');
      $('.select-color-haven .spb-helptext').appendTo('.select-color-haven #fabric_colour_haven-0-5');
      $('.select-color-plush .spb-helptext').appendTo('.select-color-plush #select_your_fabric_colour_plush-0-6');
      //$('.base-fabric-choice span label:first-child').addClass('base-fabric-clicked');
      //$('.base-type-option span label:first-child').addClass('base-option-clicked');
      //$('.bed-head-type span label:first-child').addClass('bedhead-option-clicked');
      $('.base-info-section').prepend('<div class="base-info-section-text">Expertly hand crafted with integrated storage, this bed base offers a sophisticated solution for maximizing space without compromising on style.</div>');
      $('.base-info-section').append('<div class="base-info-section-selection">Style Selected: <span class="style-selected"></span><br/>Colour Selected: <span class="color-selected"></span></div>');
      
      $('.bedhead-info-area').prepend('<div class="bedhead-info-section-text">Indulge in the luxurious simplicity of this handcrafted bedhead.  Crafted with the finest materials, its timeless design adds a touch of understated elegance to any bedroom.</div>');
      $('.bedhead-info-area').append('<div class="bedhead-info-section-selection">Style Selected: <span class="bedhead-style-selected"></span><br/>Colour Selected: <span class="color-selected"></span></div>');
      
      fabricMain = $('.base-fabric-clicked input[name="properties[base_fabric_choice]"]:checked').val();
      bedhead = $('.bed-head-type input[name="properties[Bed Head Type]"]:checked').val();
      $('.style-selected').html(fabricMain);
      $('.bedhead-style-selected').html(bedhead);
      $('.base-type-onpage').appendTo('.base-type-select');
      $('.bedhead-type-onpage').appendTo('.bedhead-select');
      
      
      $('.base-fabric-choice span label').each(function(){
        $(this).click(function(){
            $('.base-fabric-choice span label').removeClass('base-fabric-clicked');
          $(this).addClass('base-fabric-clicked');
          fabricMain = $('.base-fabric-clicked input[name="properties[base_fabric_choice]"]:checked').val();
          $('.style-selected').html(fabricMain);
          showbasePreview(fabricMain,colorMain,base);
          showheadPreview(fabricMain,colorMain,bedhead);
          generateList(fabricMain,colorMain,base,bedhead,baseFeet);
          displayVariant(selectedVariantId,colorMain,fabricMain,base,bedhead);
        });
      });
      $('.base-type-option span label').each(function(){
        $(this).click(function(){
            $('.base-type-option span label').removeClass('base-option-clicked');
          $(this).addClass('base-option-clicked');
          base = $('.base-type-option input[name="properties[Base Type Option]"]:checked').val();
          showbasePreview(fabricMain,colorMain,base);
          generateList(fabricMain,colorMain,base,bedhead,baseFeet);
          displayVariant(selectedVariantId,colorMain,fabricMain,base,bedhead);
          $('.base-type-select').css('height','auto');
          $('.base-type-select').css('overflow','unset');
          $('.base-type-select').css('visibility','visible');
        });
      });  
      $('.bed-head-type span label').each(function(){
        $(this).click(function(){
            $('.bed-head-type span label').removeClass('bedhead-option-clicked');
          bedhead = $('.bed-head-type input[name="properties[Bed Head Type]"]:checked').val();
          $(this).addClass('bedhead-option-clicked');
          $('.bedhead-style-selected').html(bedhead);
          showheadPreview(fabricMain,colorMain,bedhead);
          generateList(fabricMain,colorMain,base,bedhead,baseFeet);
          displayVariant(selectedVariantId,colorMain,fabricMain,base,bedhead);
          $('.bedhead-select').css('height','auto');
          $('.bedhead-select').css('overflow','unset');
          $('.bedhead-select').css('visibility','visible');
        });
      }); 

      $('.base-feet-options span label').click(function(){
          baseFeet = $('input[name="properties[Base Feet]"]',this).val();
          generateList(fabricMain,colorMain,base,bedhead,baseFeet);
      });
      
        $('.mattress-add-link').click(function(e){
          e.preventDefault();
          var popupType = $(this).attr('id');
          console.log(popupType);
          $('.overlay').css('visibility','visible');
          $('.overlay').css('opacity','1');
          
          var colorFabric ="";
          if(fabric.includes('Augustus')){fabric = 'Augustus';colorFabric = $('.select-color select').val();}
          if(fabric.includes('Haven')){fabric = 'Haven';colorFabric = $('.select-color-haven select').val();}
          if(fabric.includes('Plush')){fabric = 'Plush';colorFabric = $('.select-color-plush select').val();}             
          bedhead = $('.bed-head-type select').val();
          //base = $('.base-type-option select').val(); 
          colorFabric = colorFabric.split("- ");

          if(popupType == 'base-fabric-option'){
            
            var fabLower = fabric.toLowerCase();
            var colorSrc = $('.'+fabLower+'-swatch .spb-productoptionswatchwrapper .'+colorFabric[1]).attr('data-color-img');
            console.log("Fabric: "+fabLower);
            console.log("Color: "+colorFabric[1]);            
            console.log("Color SRC: "+colorSrc);
            $('.color-selected').html(colorFabric[1]);
            $('.fabric-img img').attr('src',colorSrc);
            $('.bed-popup-content').hide();
            $('.popup .fabric-content').show();
          }
          
          if(popupType == 'base-type-option'){
          
          baseTypeColor = 'cell-'+colorFabric[1].trim();
            $('.basetype-content .main-carousel .carousel-cell').each(function(){
              $(this).show();
            if($(this).hasClass(baseTypeColor)){}else
              $(this).hide();
          });
            
            $('.bed-popup-content').hide();
            $('.popup .basetype-content').show();
          }
          if(popupType == 'bed-head-option'){
          headTypeColor = 'cell-'+colorFabric[1].trim();
            $('.bedhead-content .main-carousel .carousel-cell').each(function(){
              $(this).show();
            if($(this).hasClass(headTypeColor)){}else
              $(this).hide();
          });            
            $('.bed-popup-content').hide();
            $('.popup .bedhead-content').show();
          }
          if(popupType == 'adjustable-option'){
            $('.bed-popup-content').hide();
            $('.popup .adjustable-content').show();
          }
          if(popupType == 'base-feet-option'){
            $('.bed-popup-content').hide();
            $('.popup .basefeet-content').show();
          }
          
          if(fabric == 'Augustus'){
            $('h2.fabric-content').text('Fabric Type: Augustus');
            $('.color-options-popup .prod-option-swatch').hide();
            $('.color-options-popup .augustus-swatch').show();
            $('.fabric-main-content').hide();            
            $('.augustus-content').show();   
            
          }
          if(fabric == 'Haven'){
            
            $('h2.fabric-content').text('Fabric Type: Haven');
            $('.color-options-popup .prod-option-swatch').hide();
            $('.color-options-popup .haven-swatch').show();
            $('.fabric-main-content').hide();            
            $('.haven-content').show();            
            
          }
          if(fabric == 'Plush'){
            $('h2.fabric-content').text('Fabric Type: Plush');
            $('.color-options-popup .prod-option-swatch').hide();
            $('.color-options-popup .plush-swatch').show();
            $('.fabric-main-content').hide();            
            $('.plush-content').show();  
            

          }          
          //Bedhead Selection
          if(fabric=='Augustus' && bedhead=='Naya'){
            $('.bedhead-slider').hide();
            $('.naya-augustus').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.naya-augustus').addClass('visible-slider');
          }
          if(fabric=='Augustus' && bedhead=='Stella'){
            $('.bedhead-slider').hide();
            $('.stella-augustus').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.stella-augustus').addClass('visible-slider');
          }
          if(fabric=='Augustus' && bedhead=='Willow'){
            $('.bedhead-slider').hide();
            $('.willow-augustus').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.willow-augustus').addClass('visible-slider');
          }
          if(fabric=='Haven' && bedhead=='Naya'){
            $('.bedhead-slider').hide();
            $('.naya-haven').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.naya-haven').addClass('visible-slider');
          }
          if(fabric=='Haven' && bedhead=='Stella'){
            $('.bedhead-slider').hide();
            $('.stella-haven').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.stella-haven').addClass('visible-slider');
          }
          if(fabric=='Haven' && bedhead=='Willow'){
            $('.bedhead-slider').hide();
            $('.willow-haven').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.willow-haven').addClass('visible-slider');
          }
          // PLUSH
          if(fabric=='Plush' && bedhead=='Naya'){
            $('.bedhead-slider').hide();
            $('.naya-plush').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.naya-plush').addClass('visible-slider');
          }
          if(fabric=='Plush' && bedhead=='Stella'){
            $('.bedhead-slider').hide();
            $('.stella-plush').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.stella-plush').addClass('visible-slider');
          }
          if(fabric=='Plush' && bedhead=='Willow'){
            $('.bedhead-slider').hide();
            $('.willow-plush').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.willow-plush').addClass('visible-slider');
          }          

          //Base Selection
          if(fabric=='Haven' && base=='Twin Base'){
            $('.base-slider').hide();
            $('.twin-haven').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.twin-haven').addClass('base-visible-slider');
          }
          if(fabric=='Haven' && base=='Drawer Base'){
            $('.base-slider').hide();
            $('.drawer-haven').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.drawer-haven').addClass('base-visible-slider');
          } 
          if(fabric=='Haven' && base=='Floating Base'){
            $('.base-slider').hide();
            $('.floating-haven').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.floating-haven').addClass('base-visible-slider');
          }
          if(fabric=='Augustus' && base=='Floating Base'){
            $('.base-slider').hide();
            $('.floating-augustus').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.floating-augustus').addClass('base-visible-slider');
          }
          if(fabric=='Augustus' && base=='Twin Base'){
            $('.base-slider').hide();
            $('.twin-augustus').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.twin-augustus').addClass('base-visible-slider');
          }
          if(fabric=='Augustus' && base=='Drawer Base'){
            $('.base-slider').hide();
            $('.drawer-augustus').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.drawer-augustus').addClass('base-visible-slider');
          }     
          // Base PLUSH
          if(fabric=='Plush' && base=='Twin Base'){
            $('.base-slider').hide();
            $('.twin-plush').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.twin-plush').addClass('base-visible-slider');
          }
          if(fabric=='Plush' && base=='Drawer Base'){
            $('.base-slider').hide();
            $('.drawer-plush').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.drawer-plush').addClass('base-visible-slider');
          } 
          if(fabric=='Plush' && base=='Floating Base'){
            $('.base-slider').hide();
            $('.floating-plush').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.floating-plush').addClass('base-visible-slider');
          }
          
        });        

      $('.popup .close').click(function(){
        $('.overlay').css('visibility','hidden');
          $('.overlay').css('opacity','0');
      })
      /* Change Preview Format of Fabric and Colour base on click */
      $('.fabric-content .prod-option-swatch span .spb-productoptionswatchwrapper').click(function(){
        var colorVal = $('.spb-productoptionswatch',this).attr('data-color-img');
        $('.fabric-img img').attr('src',colorVal);
        $('.color-selected').html($('input',this).val());
      });

      
      /* Select the available size */

      //if ( $(".adjustable-option select option[value='" + valueSelected + "']").val() === undefined) {exists=1;}
      //if(exists == 0){
        //$('.adjustable-option select option').each(function(){
         // if(valueSelected != $(this).val()){
            //$(this).hide();
          //}
        //});        
     // }       
      //INITIAL LOAD
      filterOptions(selectedVariantId,colorMain);


      $(document).on('change', ".base-type-select select", function (e) {
        //console.log('BASE: '+$(this).val());
      });      
      $(document).on('change', ".bedhead-select select", function (e) {
        //console.log('BED: '+$(this).val());
      });        

      //PREVIEW CODE;
      var previewHtml="<div class='preview-list'></div>";
      $('.mattress-notes').prepend(previewHtml);
      $('.bed-shipping').appendTo('.infinite-del-ship');      
      $('.additional-options').appendTo('.infinite-del-ship');
      
      var build = $('input[name="properties[Ensemble]"]:checked').val();
      //console.log("Build "+build);
      previewList(build);
      //build-ensemble
      $(document).on('change', ".build-ensemble input[type=radio]", function (e) {
        build = $('input[name="properties[Ensemble]"]:checked').val();
        //console.log("Build "+build);
        if(build.includes('Yes')){
          $('.preview-list').show();
        }
        if(build.includes('No')){
          $('.preview-list').hide();
        }        
        
        previewList(build);
      });

    function showbasePreview(fabric,color,baseSelection){

          var baseType="";
          var fabricType="";
          var baseDisplay="";
          baseTypeColor = 'cell-'+color.trim();
      
          
          if(fabric!=undefined&&color!=undefined&&baseSelection!=undefined){
            console.log('Fabric: '+fabric);
            console.log('Color: '+color);
            console.log('Base Selection: '+baseSelection);
            if(fabric.includes('Augustus') && baseSelection.includes('Twin')){
              fabricType="augustus";baseType= "twin";               
            }
            if(fabric.includes('Haven') && baseSelection.includes('Twin')){
              fabricType="haven";baseType= "twin";               
            }
            if(fabric.includes('Plush') && baseSelection.includes('Twin')){
              fabricType="plush";baseType= "twin";               
            }
            if(fabric.includes('Augustus') && baseSelection.includes('Floating')){
              fabricType="augustus";baseType= "floating";               
            }
            if(fabric.includes('Haven') && baseSelection.includes('Floating')){
              fabricType="haven";baseType= "floating";               
            }
            if(fabric.includes('Plush') && baseSelection.includes('Floating')){
              fabricType="plush";baseType= "floating";               
            }
            if(fabric.includes('Augustus') && baseSelection.includes('Drawer')){
              fabricType="augustus";baseType= "drawer";               
            }
            if(fabric.includes('Haven') && baseSelection.includes('Drawer')){
              fabricType="haven";baseType= "drawer";               
            }
            if(fabric.includes('Plush') && baseSelection=='Drawer'){
              fabricType="plush";baseType= "drawer";               
            }            
              baseDisplay = "."+baseType+"-"+fabricType;  
              //console.log('Base Selected');
              $('.base-slider').hide();
              $(baseDisplay).attr('style', 'display: block !important');;
            $('.base-slider').removeClass('base-visible-slider');
            $(baseDisplay).addClass('base-visible-slider');            
            $('.basetype-content .main-carousel .carousel-cell').each(function(){
              $(this).show();
            if($(this).hasClass(baseTypeColor)){
              $(this).show();
            }else
              $(this).hide();
          });
            
          }
    }
    function showheadPreview(fabric,color,headSelection){

          var headType="";
          var fabricType="";
          var headDisplay="";
          var headTypeColor="";
          headTypeColor = 'cell-'+color.trim();      
          
          if(fabric!=undefined&&color!=undefined&&headSelection!=undefined){
            console.log('Fabric: '+fabric);
            console.log('Color: '+color);
            console.log('Head: '+headSelection);
            if(fabric.includes('Augustus') && headSelection.includes('Naya')){fabricType="augustus";headType= "naya";}
            if(fabric.includes('Haven') && headSelection.includes('Naya')){fabricType="haven";headType= "naya";}
            if(fabric.includes('Plush') && headSelection.includes('Naya')){fabricType="plush";headType= "naya";}
            if(fabric.includes('Augustus') && headSelection.includes('Stella')){fabricType="augustus";headType= "stella";}
            if(fabric.includes('Haven') && headSelection.includes('Stella')){fabricType="haven";headType= "stella";}
            if(fabric.includes('Plush') && headSelection.includes('Stella')){fabricType="plush";headType= "stella";}
            if(fabric.includes('Augustus') && headSelection.includes('Willow')){fabricType="augustus";headType= "willow";}
            if(fabric.includes('Haven') && headSelection.includes('Willow')){fabricType="haven";headType= "willow";}
            if(fabric.includes('Plush') && headSelection.includes('Willow')){fabricType="plush";headType= "willow";}            

            headTypeColor = 'cell-'+color.trim();
            headDisplay = "."+headType+"-"+fabricType;
            $('.bedhead-slider').hide();
            $('.bedhead-type-onpage').show();
            $(headDisplay).show();
            $('.bedhead-slider').removeClass('base-visible-slider');
            $(headDisplay).addClass('base-visible-slider');
            $(headDisplay).attr('style', 'display: block !important');
                          
            
            $('.bedhead-content .main-carousel .carousel-cell').each(function(){
              $(this).show();
            if($(this).hasClass(headTypeColor)){
              $(this).show();
            }else
              $(this).hide();
          });
          }
    }      
    function previewList(preview){
      if(preview != undefined){
        if (preview.indexOf('Yes') !== -1) {
          generateList(fabricMain,colorMain,base,bedhead);   
           $(document).on('change', ".bed-product select", function (e) {
             generateList();  
           });
           $(document).on('change', ".bed-product .buy-adjustable input[name='properties[buy_adjustable_base]']", function (e) {
             generateList();  
           });        
        }else
          $('.preview-list').empty();        
      }

    }
    function displayVariant(size,color,fabric,baseSelection,headSelection){
          var baseType="";
          var headType="";
          var fabricType="";
          var varDisplay="";
          var varheadDisplay="";
          var baseDisplay="";
          var headDisplay="";
      if(size!=undefined&&color!=undefined&&fabric!=undefined){
      console.log('COLOR Variant: '+color);
      console.log('SIZE Variant: '+size);       
      console.log('BASE Variant: '+baseSelection);
     console.log('FABRIC Variant: '+fabric);   
        
            if(fabric.includes('Augustus') && baseSelection.includes('Twin')){fabricType="Augustus";baseType= "Twin";}
            if(fabric.includes('Haven') && baseSelection.includes('Twin')){fabricType="Haven";baseType= "Twin";}
            if(fabric.includes('Plush') && baseSelection.includes('Twin Base')){fabricType="Plush";baseType= "Twin";}
            if(fabric.includes('Augustus') && baseSelection.includes('Floating')){fabricType="Augustus";baseType= "Floating";}
            if(fabric.includes('Haven') && baseSelection.includes('Floating')){fabricType="Haven";baseType= "Floating";}
            if(fabric.includes('Plush') && baseSelection.includes('Floating')){fabricType="Plush";baseType= "Floating";}
            if(fabric.includes('Augustus') && baseSelection.includes('Drawer')){fabricType="Augustus";baseType= "Drawer";}
            if(fabric.includes('Haven') && baseSelection.includes('Drawer')){fabricType="Haven";baseType= "Drawer";}
            if(fabric.includes('Plush') && baseSelection.includes('Drawer')){fabricType="Plush";baseType= "Drawer";}

        varDisplay = baseType+" - "+fabricType;
        console.log('VARIANT DISPLAY:'+varDisplay);
        baseDisplay = baseType.toLowerCase()+"-"+fabricType.toLowerCase();
        console.log('CLASS FOR BASE DISPLAY:'+baseDisplay);
        $('.base-type-select span label').each(function(){
          var baseV = $('input[name="properties[Base Type '+varDisplay+']"]',this).val();
          if(baseV!=undefined){
            if(baseV.includes(size)&&baseV.includes(color)){
              $('.base-type-select-'+baseDisplay).show();
              $('.base-type-select .spb-productoptionswatchwrapper').addClass('hide-base-variant');  
              $(this).removeClass('hide-base-variant');
              console.log('BASE: '+baseV);
              return false;
            }            
          }
        });

          if(headSelection!=undefined){
            if(fabric.includes('Augustus') && headSelection.includes('Naya')){fabricType="Augustus";headType= "Naya";}
            if(fabric.includes('Haven') && headSelection.includes('Naya')){fabricType="Haven";headType= "Naya";}
            if(fabric.includes('Plush') && headSelection.includes('Naya')){fabricType="Plush";headType= "Naya";}
            if(fabric.includes('Augustus') && headSelection.includes('Stella')){fabricType="Augustus";headType= "Stella";}
            if(fabric.includes('Haven') && headSelection.includes('Stella')){fabricType="Haven";headType= "Stella";}
            if(fabric.includes('Plush') && headSelection.includes('Stella')){fabricType="Plush";headType= "Stella";}          
            if(fabric.includes('Augustus') && headSelection.includes('Willow')){fabricType="Augustus";headType= "Willow";}
            if(fabric.includes('Haven') && headSelection.includes('Willow')){fabricType="Haven";headType= "Willow";}
            if(fabric.includes('Plush') && headSelection.includes('Willow')){fabricType="Plush";headType= "Willow";}              
          }
        
        varheadDisplay = headType+" "+fabricType;
        console.log('VARIANT HEAD DISPLAY:'+varheadDisplay);
        headDisplay = headType.toLowerCase()+"-"+fabricType.toLowerCase();
        
        $('.bedhead-select span label').each(function(){
          var headV = $('input[name="properties[Bed Head '+varheadDisplay+']"]',this).val();
          if(headV!=undefined){
            if(headV.includes(size)&&headV.includes(color)){
              $('.bedhead-select-'+headDisplay).show();
              $('.bedhead-select .spb-productoptionswatchwrapper').addClass('hide-base-variant');  
              $(this).removeClass('hide-base-variant');
              console.log('HEAD: '+headV);
              return false;
            }            
          }

        });        
      }
    }      
    function adjustSelection(mattressSize){
        //console.log('Mattress Size:'+mattressSize);
      $('.adjustable-option span label').each(function(){
        
        if($('input',this).val()==mattressSize){
          console.log('Adjustable Label:'+$('input',this).val());
          $('.adjustable-option span label').addClass('hide-ensemble-part');
          $(this).removeClass('hide-ensemble-part');
          return false;
        }else{
          $('.adjustable-option span label').removeClass('hide-ensemble-part');
        }
      });
      
    }
    function filterOptions(mattressValue,colorOption){
      //console.log("Color Main:"+colorOption);
      var colorSplit = colorOption.split("- ");
      /* INITIAL BASE OPTIONS */
      if ( $(".base-type-select select option[value*='" + mattressValue + "']").val() === undefined) {baseExists=1;}  
        //console.log("value: "+mattressValue);
        $('.base-type-select select option').each(function(){
          var splitSize = ($(this).val()).split("/");
          var splitTrim = splitSize[0].trim();
          var splitColor ="";
          if(splitSize[1]!=undefined){
            splitColor = splitSize[1].trim();
          }
          if(mattressValue == splitTrim){
              if(colorSplit[1] == splitColor){
                $(this).show();
              }else
                $(this).hide();
          }else
            $(this).hide();
        });      
      /* INITIAL BED HEAD OPTIONS */
      if ( $(".bedhead-select select option[value*='" + mattressValue + "']").val() === undefined) {headExists=1;}  
        $('.bedhead-select select option').each(function(){
          var splitSize = ($(this).val()).split("/");
          var splitTrim = splitSize[0].trim();
          var splitColor ="";
          if(splitSize[1]!=undefined){
            splitColor = splitSize[1].trim();
          }
          if(mattressValue == splitTrim){
              if(colorSplit[1] == splitColor){
                $(this).show();
              }else
                $(this).hide();
          }else
            $(this).hide();
        });  
    }      

    function generateList(fabric,color,base,bedhead,baseFeet){
        $('.preview-list').empty();
        $('.preview-list').html('<h3>Your Bed Selections are detailed as follows:</h3><div class="preview-list-content"></div><div class="preview-footer">To make any adjustments, please reselect your options</div>');
        $('.preview-list-content').append('<span>Mattress Size: '+selectedVariantId+'</span><br>');
        $('.preview-list-content').append('<span>Mattress Firmness: '+$('.product__title h1').text()+'</span><br>');
        if($('.buy-adjustable input[name="properties[buy_adjustable_base]"]:checked').val() != null){
          $('.preview-list-content').append('<span>Adjustable Base:'+$('.buy-adjustable input[name="properties[buy_adjustable_base]"]:checked').val()+'</span><br>');  
        }
        if(base != ""){
          $('.preview-list-content').append('<span>Base Fabric and Colour: '+fabric+' - '+base+' - '+color+'</span><br>');
        }
        if(baseFeet != null){
          $('.preview-list-content').append('<span>Base Feet: '+baseFeet+'</span><br>');  
        }   
        if(bedhead != ""){
          $('.preview-list-content').append('<span>Bedhead Fabric and Colour: '+fabric+' - '+bedhead+' - '+color+'</span><br>');
        } 
        //if(colorMain != ""){
          //$('.preview-list-content').append('<span>Base and Bedhead Color: '+colorMain+'</span><br>');  
        //}    

        $('.preview-bed-link').click(function(e){
          var fabric = ($('.base-fabric-choice select').val());
          if(fabric.includes('Augustus')){fabric = 'Augustus';}
          if(fabric.includes('Haven')){fabric = 'Haven';}
          if(fabric.includes('Plush')){fabric = 'Plush';} 
          fabric = fabric.toLowerCase();
          
          var bedhead = $('.bed-head-type select').val();
          var base = $('.base-type-option select').val();
          var classText="";
          if (base.indexOf('Twin') !== -1) {
            classText='twin-'+fabric;
          }
          if (base.indexOf('Floating') !== -1) {
            classText='floating-'+fabric;
          }
          if (base.indexOf('Drawer') !== -1) {
            classText='drawer-'+fabric;
          }          
          //console.log(classText);
          
          e.preventDefault();      
          window.dispatchEvent(new Event('resize'));
          var prevpopupType = $(this).attr('id');
          console.log(prevpopupType);
          $('.overlay').css('visibility','visible');
          $('.overlay').css('opacity','1');          
          if(prevpopupType == 'preview-base-type-option'){
            $('.bed-popup-content').hide();
            $('.popup .preview-base-content').show();
            $('.popup .preview-base-content .'+classText).show();
          }
          var str = $('.base-type-select select').val();
          var previewColor = str.split("/");
          previewColor = 'cell-'+previewColor[1].trim();
            $('.preview-base-content .main-carousel .carousel-cell').each(function(){
              $(this).show();
            if($(this).hasClass(previewColor)){
              
            }else
              $(this).hide();
          });
          
        });        
    }  

//ADDITIONAL TEXT
      $('.mattress-notes').prepend("<div class='final-delivery'><div class='final-delivery-list'></div></div>");
      var adjYes = '';
      var ensYes = '';
      if((document.querySelector('input[name="properties[Shipping]"]:checked'))!=null){
        var propShip=document.querySelector('input[name="properties[Shipping]"]:checked').value;  
      }
        $('input[name="properties[buy_adjustable_base]').click(function() {
          adjYes = $(this).val();
          console.log(adjYes+" PLUS "+ensYes);
          finalDel(adjYes,ensYes,propShip)
        });
        $('input[name="properties[Ensemble]').click(function() {
          ensYes = $(this).val();
          console.log(adjYes+" PLUS "+ensYes);
          finalDel(adjYes,ensYes,propShip)
        });
        $('input[name="properties[Shipping]').click(function() {
          propShip = $(this).val();
          finalDel(adjYes,ensYes,propShip)
        });
      

      function finalDel(adjYes,ensYes,propShip){
        var delFee='';
        if(adjYes == "Yes" && (ensYes.indexOf("Yes")!== -1)){
          console.log(adjYes+" PLUS "+ensYes);
          $('.final-delivery-list').empty();
          $('.final-delivery .final-delivery-list').append("<h2>Final Delivery Cost</h2>");
          $('.final-delivery .final-delivery-list').append("<h3>Selected Delivery Option: <span>"+propShip+"</span></h3>");
          if(propShip.indexOf('165')!==-1){
            delFee="$"+(165+100);
            $('.final-delivery .final-delivery-list').append("<h3>Additional Items <span>(more than one Bed item selected) - $100</span><h3>");
          }
          if(propShip.indexOf('275')!==-1){
            delFee="$"+(275+100);
            $('.final-delivery .final-delivery-list').append("<h3>Additional Items <span>(more than one Bed item selected) - $100</span><h3>");  
          }
          if(propShip.indexOf('250km')!==-1){
            delFee="Custom Delivery Fee";
          }          
          
          $('.final-delivery .final-delivery-list').append("<h3>Total Delivery: <span>"+delFee+"</span></h3>");
        }else{
          $('.final-delivery-list').empty();
        }        
      }
      
      
    }, 3000);  


  
    //HIDE ENSEMBLE TEXT
    var divs = document.querySelectorAll(".product-option");
    Array.from(divs).forEach(function(div) {
      if (div.textContent.indexOf("Ensemble") >= 0) {
        div.style.display = "none";
      }
    });


  //dropdown redirect
  $(document).on('change', ".mattress-type-redirects", function (e) {
   window.location = $(this).val();
  });

  var url = window.location;
  console.log("URL: "+url);
  if(url == 'https://creswickwool.com/collections/accessories/glove'){
    window.location = "https://creswickwool.com/collections/womens-gloves";
  }
  if(url == 'https://creswickwool.com/collections/accessories/hats%20and%20beanies' || url == 'https://creswickwool.com/collections/accessories/hats-and-beanies'){
    window.location = "https://creswickwool.com/collections/womens-hat-and-beanies";
  }  
  if(url == 'https://creswickwool.com/collections/accessories/ns'){
    window.location = "https://creswickwool.com/collections/accessories";
  }
  if(url == 'https://creswickwool.com/collections/accessories/scarf'){
    window.location = "https://creswickwool.com/collections/womens-scarf";
  }
  if(url == 'https://creswickwool.com/collections/accessories-gifts/soaps-&-diffusers' || url == 'https://creswickwool.com/collections/accessories-gifts/candle' || url == 'https://creswickwool.com/collections/accessories-gifts/clothing%20protector' || url == 'https://creswickwool.com/collections/accessories-gifts/clothing-protector' || url == 'https://creswickwool.com/collections/accessories-gifts/ns' || url == 'https://creswickwool.com/collections/accessories-gifts/soaps%20&%20diffusers'){
    window.location = "https://creswickwool.com/collections/accessories-gifts";
  }
  if(url == 'https://creswickwool.com//pages/about'){
    window.location = "https://creswickwool.com/pages/about-us";
  }
  //if(url == 'https://creswickwool.com/account/login?return_url=%2Faccount'){
    //if(Cookies.get('reg-account-cookie')){
      //Cookies.remove('reg-account-cookie');
      //window.location = "https://creswickwool.com/pages/activate-email";
    //}
  //}  
    if(url == 'https://creswickwool.com/pages/activate-email'){
      Cookies.remove('reg-account-cookie');
      console.log("ACCOUNT COOKIE: "+Cookies.get('reg-account-cookie'));
      if($('body').hasClass('logged-in')){
        window.location = "https://creswickwool.com/account";
      }
  }    
    if(url == 'https://creswickwool.com/collections/linen'){
    window.location = "https://creswickwool.com/collections/linen-homewares";
  }  
    if(url == 'https://creswickwool.com/collections/collections-recycled-wool'){
    window.location = "https://creswickwool.com/collections/recycled-wool-blankets";
  }  
    if(url == 'https://creswickwool.com/collections/australian-made'){
    window.location = "https://creswickwool.com/collections/australian-made-2";
  }    
  
  
  

  //hover image collection
  setTimeout(function() {
    console.log('Color Clicked INIT');
    $('.template-collection .ss__result').each(function(){


      //ADD REWARDS PRICING TAG ON 
      var dataValue = $('.wishlist-engine',this).data("product_id");
      //console.log('DATAVALUE: '+dataValue);
      //if (dataValue && dataValue.includes('6986754949229')) {
        //$('.card__badge',this).append('<span class="badge essential-card-badge" style="">Rewards Price</span>');
      //}
      //if (dataValue && dataValue.includes('6960381689965')) {
        //$('.card__badge',this).append('<span class="badge essential-card-badge" style="">Rewards Price</span>');
      //}      

      

      //if($('body').hasClass('col-ultra-luxury-mattress')){
        //$('.card__badge',this).append('<span class="badge badge--bottom-left color-accent-2 ss__badge--new" style="background:rgb(56, 66, 47) !important;display:block !important;">New</span>');
        //$('.ss__badge--sale').html('40% Off');
      //}
      //if($('body').hasClass('template-collection-mattresses')){
        //$('.ss__badge--sale').html('40% Off');
      //}      
      //if($('body').hasClass('col-new-spring-clothing-1') || $('body').hasClass('col-new-spring-accessories-24') || $('body').hasClass('col-womens-resort-collection') || $('body').hasClass('col-womens-bamboo-collection') || $('body').hasClass('col-womens-linen-collection')){
        //$('.card__badge',this).append('<span class="badge badge--bottom-left color-accent-2 ss__badge--new" style="background:rgb(56, 66, 47) !important;">New</span>');
      //}      
      //if($('body').hasClass('col-new-winter-accessories') || $('body').hasClass('col-new-winter-2025') || $('body').hasClass('col-womens-winter-clothing') || $('body').hasClass('col-new-winter-unique-2025') || $('body').hasClass('col-new-winter-mens-clothing')){
        //if($('.card__badge span',this).hasClass('ss__badge--new')){}else{
          //$('.card__badge',this).append('<span class="badge badge--bottom-left color-accent-2 ss__badge--new" style="background:rgb(56, 66, 47) !important;">New</span>');  
        //}
      //}
      if($('body').hasClass('col-recycled-wool-blankets') || $('body').hasClass('col-recycled-wool-throws')){
          if($('.card__badge',this).find('.ss__badge--recycled').length !== 0){
            
          }else{
            $('.card__badge',this).append('<span id="NoMediaStandardBadge-template--14601942564973-grid-6986750460013-Colour-Beige Chocolate" class="badge badge--bottom-left color-accent-2 ss__badge--recycled" style=""><img src="https://cdn.shopify.com/s/files/1/0559/9825/1117/files/recycle_cricle-hires-white_green.png?v=1704847831" alt="Recycled"></span>');
          }
      }
        


      
      $('.colour-fieldset label.color-swatch',this).click(function(){
          var result = $(this).closest('.ss__result');
          $('.ss__result__image .media.media--hover-effect>img+img',result).addClass('second-img');
          console.log(result);
          console.log('Color Clicked');
          //$('.badge-clearance-outlet',result).html('CLEARANCE OUTLET');

        
        //run the update again
        //setTimeout(function() {
         // if($('.card__badge .ss__badge--sale',result).hasClass('badge-clearance-outlet')){
          //$('.badge-clearance-outlet',result).html('CLEARANCE OUTLET');
          //}
       // }, 1000);  
          
      });  

      //size change
      $('.size-fieldset',this).click(function(){
      var result1 = $(this).closest('.ss__result');
      //$('.badge-clearance-outlet',result1).html('CLEARANCE OUTLET');
     });   

    //multi badge  
    var multiTitle = $('.ss__result__name',this).text();
    var packMessage="";  
      
        if (multiTitle.indexOf('2 Pack') !== -1) {
          packMessage ='2 Pack';
        }
        if (multiTitle.indexOf('3 Pack') !== -1) {
          packMessage ='3 Pack';
        }
        if (multiTitle.indexOf('4 Pack') !== -1) {
          packMessage ='4 Pack';
        }
        if (multiTitle.indexOf('10 Pack') !== -1) {
          packMessage ='10 Pack';
        }
        if (multiTitle.indexOf('12 Pack') !== -1) {
          packMessage ='12 Pack';
        }      
        //console.log('Pack Message: '+packMessage);
          if(packMessage !=''){
            if($('.card__content .main-prod-card-link',this).find('.card-multi-badge').length !== 0){}else{
              $('.card__content .main-prod-card-link',this).append('<div class="card__badge bottom right ss__badge__container card-multi-badge"><span class="multi-badge badge">'+packMessage+'</span>');  
          }
        } 
      
    });
  }, 3000);  

  $('.col-afterdark-promo .banner__media').append('<img src="https://cdn.shopify.com/s/files/1/0559/9825/1117/files/Mobile_After_Dark_414x155_1.jpg?v=1693548559" class="hide-desktop">');

  //Upsell button
  $('.icon-cart').click(function(){
     $(".upsell-container").toggleClass("show-upsell"); 
  });
  $('.drawer__close').click(function(){
    $("cart-drawer").removeClass("move-cart");
  }); 
  
  //Check li number in megamenu sublist
  $('.mega-menu').each(function(){
   // console.log($('.mega-menu__list > li',this).length);
    var lenClass = 'length-'+$('.mega-menu__list > li',this).length;
    $(this).addClass(lenClass);
  });

  setTimeout(function() {
    var yotpo_rating = $('.product__info-container .yotpo-sr-bottom-line-score').html();
    if(yotpo_rating != undefined){
      console.log('Yotpo Rating: '+parseFloat(yotpo_rating.trim()));
      var yotpo_num = parseFloat(yotpo_rating.trim());
        $('.product__info-container .yotpo-sr-bottom-line-score').html('<span class="yotpo-extra-text">See Reviews</span>');
        $('.product__info-container .yotpo-sr-bottom-line-score').css("cssText", "display: block !important;");

      $('#yotpo-reviews-star-ratings-widget .yotpo-sr-bottom-line-button[aria-label*="reviews"]').each(function() {
        let text = $(this).attr('aria-label');
        let match = text.match(/(\d+)\s+reviews/); // find the number before "reviews"

        if (match) {
          let reviewsCount = match[1];
          $('.product__info-container #yotpo-reviews-star-ratings-widget').append('<span class="based-on-reviews">Based on '+reviewsCount+' reviews</span>');
        }
      });        
    }


    //HIDE NEW IF THERE IS A SALE TAG
    const outletSKU = ["40558917779565","40506177880173","40506177912941","40558917812333","40506177945709","40506177978477","40506184368237","40506184401005","40506184433773","40506184466541","40506189807725","40506189840493","40506189873261","40506187808877","40506187841645","40506187874413","40506187907181","40506187939949","40558937374829","41740473761901","40506201014381","40976058318957","40506201047149","40506257703021","40580659576941","40580659609709","40580613865581","40580613898349","40580613931117","40580644601965","40580644634733","40580644667501","40580644700269","40580644733037","40580644765805","40580644798573","40580608589933","40580608622701","40580608655469","40580608688237","40580608721005","40580608753773","40580608786541","40580608819309","40580608852077","40580608884845","40580608917613","40580608950381","40580608983149","40580609015917","40580609048685","40580609081453","40580609114221","40580609146989","40580664492141","40580662132845","40580662165613","40580662689901","40580662722669","40580662755437","40580662788205","40580662820973","40580662853741","40580662886509","40580662919277","40580662952045","40580662984813","40580663017581","40580663050349","40580684021869","40580684054637","40580684120173","40580684185709","40636530262125","40580698800237","40580698833005","40580698865773","40636530294893","40580698898541","40632295489645","40632295522413","40636530327661","40580698964077","40580698996845","40580699029613","40582759612525","40582759645293","40580700864621","40580700897389","40580700930157","40580700962925","40714424287341","40714424320109","40714424352877","40652379553901","40652379586669","40652379619437","40652379652205","40652379684973","40652379717741","40652379750509","40652379783277","40652379816045","40652379848813","40652379881581","40652379914349","40652379947117","40652379979885","40652380012653","40729443008621","40729443041389","40729443074157","40729443106925","40729442943085","40729442975853","40789295071341","40789295104109","40789295136877","40789295169645","40789295202413","40789295267949","9330905025091","9330905025107","9330905025114","9330905026838","9330905025121","9330905026845","9330905026791","9330905026814","9330905027354","9330905027361","9330905027408","9330905033706","9330905027378","9330905027385","9330905027392","9330905027415","9330905005994","9330905006007","9330905006014","9330905026401","9330905026425","93565424","9330905027705","93489461","9330905007356","9330905026463","9330905026487","9330905026494","9330905007417","9330905007424","9330905007431","9330905009602","9330905025091","9330905025107","93535434","9330905026791","93530859","9330905001262","9330905027699","93281973","93316743","93228855","9330905027378","9330905027385","9330905027392","9330905027415","93227810","93018050","93018036","93018043","93018005","93000406","93000116","93000185","93000260","93066218","93066219","93000413","93009119","93000123","93000192","9330905028740","9330905028757","9330905028764","9330905028771","9330905028788","9330905016341","9330905016358","93012157","93007467","93012164","93012126","93005104","93005166","93005043","93005210","93223867","93005241","93007481","93007498","93009492","93266208","93075705","9330905028924","93064405","93261067","93013611","93025720","93022354","9330905002429","9330905027699","93227940","93227902","93023146","93025461","93025454","93025485","93025478","93533034","93025508","93025522","93025515","93025492","93226318","93064419","93065347","93227919","93348003","93348027","93348065","93348072","93352406","987654321`","9330905027880","9330905027897","93428637","93536073","93495707","9330905027330","9330905027347","93525053","93515849","93536059","93536066","93516839","93525046","93525039","9330905006229","9330905006236","93515856","93525060","9330905004850","9330905004829","9330905004836","93388689","93533218","93533225","9330905014866","9330905014873","93420150","93429719","93429702","9330905013333","9330905013340","9330905013357","9330905013364","9330905013371","9330905034420","93442206","9330905002511","9330905002528","93568883","93568869","93568876","93568852","93568845","9330905033997","9330905034000","9330905034017","9330905034024","9330905034031","93016575","93007771","93012317","93000369","93217910","93428620","93007818","93000161","93000093","93000376","93000383","93000246","93000109","93000178","93063627","9330905013319","9330905013173","9330905013289","9330905013203","9330905013234","93464178","9330905013166","9330905013197","9330905013272","9330905013302","93536035","93515832","9330905025138","9330905025145","93562874","93562881","93562898","93515870","9330905025046","9330905025039","9330905025077","9330905025060","93515894","9330905028894","9330905028900","9330905028917","9330905033713","9330905033720","93523592","93522250","93569835","93522281","93522311","93489461","93489454","9330905013241","9330905013210","9330905013296","9330905013180","9330905013326","93516518","93516792","93516808","93339476","93465847","93465830","93519434","93568630","93533096","93063637","93025751","93022651","93038430","93022699","93535434","93523653","93523646","93530866","93530859","93526074","93526227","93526210","93530903","93530897","93526173","93526234","93533058","93533072","93533065","93533041","93533089","93558372","93558358","93536646","93558389","93558495","93558488","9330905029228","9330905029235","93562911","93562904","9330905001255","9330905001262","9330905001279","9330905001286","9330905005444","9330905005451","9330905018369","9330905005918","9330905005925","9330905005895","9330905005901","9330905005932","9330905005949","9330905005956","9330905005963","9330905029242","9330905029259","9330905005970","9330905005987","9330905006243","9330905016419","9330905016426","9330905016433","9330905009350","9330905009367","9330905010035","9330905009411","9330905009428","9330905010059","9330905009374","9330905009381","9330905010042","9330905022717","9330905022724","9330905022731","9330905022748","9330905022755","9330905022663","9330905022670","9330905022687","9330905022694","9330905022700","9330905022762","9330905022779","9330905022786","9330905022793","9330905022809","9330905022830","9330905022847","9330905022816","9330905022823","9330905022854","9330905022861","9330905025091","9330905025107","9330905025114","9330905026838","9330905025121","9330905026845","9330905026791","9330905026814","9330905027354","9330905027361","9330905027408","9330905033706","9330905027378","9330905027385","9330905027392","9330905027415","9330905033812","9330905033850","9330905033874","9330905033881","9330905033898","9330905033904","93411240","93411226","93411233","93411257","93443623","9330905038336","9330905038343","9330905038350","9330905038367","9330905038374","93281973","93227247","93316736","93316743","93228855","9330905016327","9330905016334","93334570","93334556","9330905015931","93339384","93339513","93339452","93339537","93339568","93339698","93339575","93339704","93339711","93339865","93516495","93489447","9330905024841","9330905024858","9330905024865","9330905024872","9330905024889","9330905024896","9330905024902","9330905024919","9330905024926","9330905026616","9330905026623","9330905026630","9330905026647","9330905026654","9330905026661","93001113","93515030","93016483","93054669","93069566","93070484","93074960","93074943","93352390","93352413","93522083","93522090","9330905000586","9330905000562","93506236","93506250","9330905000616","9330905000579","93515047","9330905000593","9330905000609","9330905029631","9330905029648","93277396","9330905016044","93063789","9330905016051","93063790","93063792","9330905016068","93530750","93063791","93530767","9330905016075","9330905016082","9330905024100","9330905024117","9330905024124","9330905026692","9330905026708","9330905026715","9330905026722","9330905026739","9330905026746","9330905026753","93233958","93530781","93530774","93530842","93530835","93530811","93568739","93568722","93531351","93531375","9330905037902","9330905037919","93568753","93568746","9330905037926","93568760","93568814","93568807","93568777","9330905025428","93568791","93568821","93489140","93372527","93264396","93283090","93283137","93283199","93437851","93510691","93510707","93510714","93510721","93510738","93510745","93510752","93510769","93510776","93516853","93532556","93296700","93562935","93567060","93567213","93516938","93516907","93516921","93565370","93523868","93523400","93523479","93565486","93565493","93522632","93522564","93522588","93522571","93522595","93522694","93522649","93522687","93522656","93535588","93535601","93535571","93535595","93535564","93536172","93536141","93536264","9330275076525","93565240","93565264","93565233","93565257","93565271","93565332","93565318","93565325","93565363","93565349","93565356","93567022","93567046","93567015","93567008","93567039","93566995","93567053","93567176","93567190","93567091","93567084","93567183","93567077","93567206","9330275093454","9330275093478","9330275093485","9330275093416","9330275093379","9330275093393","9330905036097","9330905036219","93414128","9330905038329","9330905038312","93443104","93335294","9330905038299","93395212","93409117","93410298","9330905038305","9330905023868","93570107","93569033","93569040","93569019","9330905028337","9330905028344","9330905028313","9330905028320","9330905028290","9330905028306","93520416","93526296","93526319","93526302","93568678","93526326","9330905023530","9330905023547","9330905023554","9330905023561","9330905023578","93066749","93070722","93230797","93075131","93075133","93075132","93075130","93089741","93060790","93289696","93289702","93289689","93289719","93443647","93396592","93384018","93396585","93396578","93383998","93477703","93397056","93523233","93516419","93516433","93516426","9330905022076","93516969","93516983","93516976","93516952","93523851","93535632","93535618","93535649","93535625","93536578","93536592","93536585","93536561","93536608","93000772","93309028","93023269","93516396","93025447","93214363","9330905007356","9330905024186","9330905024155","9330905024131","9330905024162","9330905024179","93570053","93570060","93570084","93535717","9330905028818","93535724","93535748","9330905028825","93535731","93562942","9330905033270","9330905033829","93522397","9330905033287","9330905033294","93007870","93069961","93507233","93515474","93060302","9330905032396","93026604","9330905014859","93522380","93053440","93059093","93063788","93005302","93038485","93063784","93038478","93007733","93038461","9330905014842","93073119","9330905014811","9330905006649","93483339","93483322","93483377","93568289","93515672","9330905006625","9330905007387","9330905007394","9330905006618","93515481","9330905033683","93568210","9330905007349","93515689","93515733","9330905006632","9330905006601","9330905026371","9330905006588","9330905006717","9330905006564","9330905006700","9330905028276","9330905006656","9330905006595","9330905026364","9330905033690","9330905026340","93515702","9330905006670","93568241","9330905006694","9330905006687","9330905014453","9330905004386","93523813","93524834","9330905027903","93524841","93523820","9330905014897","93526067","93568982","9330905015818","9330905015801","9330905033300","9330905033317","9330905015719","9330905026500","9330905026470","9330905026487","9330905026555","9330905026463","93515665","9330905026548","9330905026517","9330905026524","9330905026531","9330905026494","9330905007363","93568159","93568227","93528351","93530392","93533102","93533409","93533393","93533416","93533423","9330905001545","93535663","93535670","9330905015788","9330905015795","9330905015740","9330905015757","9330905025411","9330905015764","9330905015733","9330905015726","93558440","93558464","93558457","93568173","9330905026562","9330905026418","9330905026395","9330905026401","93568180","9330905026425","9330905006748","9330905006755","93569002","9330905005871","9330905005857","9330905005888","9330905005864","9330905006335","9330905006342","9330905007561","9330905007578","9330905006366","9330905006663","9330905026388","9330905006724","9330905026357","9330905007066","9330905015863","9330905015870","9330905025084","9330905026432","9330905026449","9330905026456","9330905027637","9330905027644","9330905027651","9330905027668","9330905027675","9330905033324","9330905033935","9330905033942","93565530","93565547","93565554","93565608","93565592","93565615","9330905033966","9330905033973","9330905033980","93063419","93063417","93063416","93063418","93063415","93063759","93205641","93063421","93063422","93063420","93033107","93033091","93033077","93033084","93033060","93046411","93054584","93033114","93044615","93033121","93070500","93070499","93070498","93066649","93070497","93205719","93205726","93070501","93070502","93070503","9330905033836","9330905033843","9330910000000","9330910000000","9330910000000","9330910000000","9330910000000","9330910000000","9330910000000","9330910000000","9330905005994","9330905006007","9330905006014","9330905026401","9330905026425","93565424","9330905027705","93558495","93558488","93489461","9330905007356","9330905026463","9330905026487","9330905026494","9330905007417","9330905007424","9330905007431","9330905009602","9330905025091","9330905025107","93535434","9330905026791","93530859","9330905001262","9330905027699","93281973","93316743","93228855","9330905027378","9330905027385","9330905027392","9330905027415"]
    
    $('.ss__result--item').each(function(){

    var col_link = $('.card__content .main-prod-card-link',this).attr('href');  
    //console.log("Collection LINK: "+col_link);  

    if(col_link.indexOf('twin-pack') != -1){
          //$('.card__badge .ss__badge--sale',this).html('NEW');
          //$('.card__badge .ss__badge--sale',this).attr('style', 'background-color:rgb(56, 66, 47) !important');
      
    }else{
      if($('.card__badge span',this).hasClass('ss__badge--sale')){
          $('.card__badge .ss__badge--new',this).hide();
      }      
    }  

    var i;
    for (i = 0; i < outletSKU.length; ++i) {
       if(col_link.indexOf(outletSKU[i]) != -1){
        //$('.card__badge .ss__badge--sale',this).html('CLEARANCE OUTLET');
        //$('.card__badge .ss__badge--sale',this).addClass('badge-clearance-outlet');
        //$('.card__badge .ss__badge--sale',this).attr('style', 'background-color:#BB252A !important');

         if($('body').hasClass('template-collection-outlet')){
            //$('.card__badge .ss__badge--sale').html('CLEARANCE OUTLET');
            //$('.card__badge .ss__badge--sale').addClass('badge-clearance-outlet');
            //$('.card__badge .ss__badge--sale').attr('style', 'background-color:#BB252A !important');           
         }else{
           //$('.price__container',this).prepend("<span class='col-outlet-grid'>Enter <a href='https://creswickwool.com/collections/outlet' target='_blank'>Outlet</a> for further 20% off</span>");
         }

         
       }
    }      

const winterSKU = ["41601673724013","40582753976429","41601673756781","41586225971309","41601673789549","41586226004077","41601673822317","40580616355949","41601673855085","40582754336877","41601673887853","41586226036845","42099111788653","41248996425837","41248996524141","42221742850157","41248996622445","42221742882925","41248996720749","42221742915693","41248996851821","42221742948461","41248996950125","42221742981229","41248997048429","42221743013997","41248997113965","42221743046765","40506151174253","40506151207021","40506151239789","40506151272557","40506151305325","40506151338093","42113068335213","42113090158701","41197222690925","42113090191469","42113110671469","41197222789229","41197222887533","42113089208429","42113109426285","42099146522733","42107056095341","41197222985837","41197223084141","42113110704237","42113090224237","41197223182445","42113110737005","42113091272813","41770822172781","41770822205549","41563969814637","41563969749101","41563969781869","41563969847405","41563969945709","41563969978477","41563970011245","41563970076781","42255328706669","41563970142317","41563970044013","41563970240621","41563970175085","41563970273389","41563970207853","41563970338925","41563970404461","41563970371693","41563970437229","41563970535533","41563970469997","41563970732141","41563970568301","41563970633837","41563970601069","41563970863213","41563970830445","41563970797677","41563970764909","41563970928749","41200359276653","42241871118445","42242160492653","41200359407725","42241871151213","42242160525421","41200359538797","42099115098221","42099115130989","41200359669869","42241922924653","42242211676269","41200359800941","42241922957421","42242211709037","40580651122797","40580651057261","40580651221101","40580651155565","40580651253869","40580651286637","40580651352173","40580651384941","40580651581549","40580651450477","40580651647085","40580651679853","41941659713645","41364600553581","41941660008557","42113132626029","41941659975789","41941659943021","41770821779565","41941659910253","41941659877485","41770821746797","41941659746413","41941659844717","41941659811949","41770821714029","41941659779181","41364600455277","41364600488045","41770821681261","41941660041325","40580659642477","40580659675245","40728448958573","40728448991341","40580659806317","40580659871853","40728449024109","40580657873005","40580657905773","40580657971309","40580658036845","40580658102381","40580658167917","41248495927405","42099125846125","42244499734637","42245091524717","41248496058477","42244654989421","42244934729837","42245091557485","41248496156781","42245105614957","42244934762605","41248496255085","42244934795373","41248496386157","42245144871021","42244934828141","42245195694189","41248496484461","42244992335981","42245195726957","41248496582765","42244992368749","42245195759725","41248496681069","41518705410157","42317879967853","42317820362861","42317820395629","42317880000621","41518705475693","42317820428397","42317861027949","41518705606765","42317845168237","42317880033389","41518705672301","42317880066157","42317845201005","42307833233517","42307833200749","42307833167981","41770689888365","41584754819181","41864076460141","41941659222125","41941659254893","41941659287661","41250237939821","40590975500397","40580670095469","40580670161005","40631469998189","41250237972589","41250238005357","42253341753453","40580670226541","40631470030957","41250238070893","40580670292077","41250238103661","40631470063725","40580670357613","40631337386093","41250238136429","40580670423149","41206647193709","42245497618541","42253331595373","41206647324781","42245497651309","42253331628141","41206647455853","42099125878893","42099125911661","41206647586925","42245503320173","42253331660909","41206647717997","42245544214637","42253331693677","41922819162221","41919527026797","41922819194989","41919527059565","41922819227757","41922819260525","41919527092333","41922819293293","41919527125101","41922819358829","41919527157869","41922819424365","41922819457133","41919527190637","41922819489901","41922819522669","40627130138733","40713243361389","40729496649837","40729496682605","40627130302573","40713243394157","40713243426925","40729496748141","40627130531949","40729496813677","40627130499181","40729496879213","40729496846445","42323793346669","42317443465325","42317630668909","41518696038509","42323792756845","42317424590957","42317630701677","42317517586541","42317424623725","42323792789613","42317630734445","42323793379437","42317443498093","41518696300653","42323793412205","42317630767213","42317443530861","42307833135213","42307827531885","42307833102445","41518696366189","40713243492461","40692383449197","40692383481965","40713243525229","42107059142765","40692383580269","42107059175533","40713243590765","40692383678573","41830692487277","41830692454509","41830692552813","41830692520045","41830692421741","41830692683885","41830692651117","41830692716653","41830692618349","41830692585581","41830692782189","41830692749421","41830692847725","41830692880493","41830692978797","41830693044333","41830693077101","41830693109869","41830693011565","41830693175405","41830693240941","41830693142637","40580698570861","40713275179117","40580698636397","40713275211885","40580698701933","40713275244653","40580702273645","41874145607789","40580701913197","40580701945965","42306278883437","40580702044269","40780426805357","40780426838125","40780426903661","40780426936429","40780427034733","40780427133037","40780427198573","40780427264109","40780427329645","40780427362413","40780427427949","40780427493485","42099148193901","41256326299757","41256326332525","42099148226669","41891778363501","41891778396269","41891778429037","41891778461805","41563912044653","42317271629933","41563912011885","41563912110189","41563912142957","42317271662701","41563912208493","42317271695469","41563912241261","41563912274029","42317271859309","41563912306797","41563912339565","42317293944941","41563912372333","42081325744237","42081325809773","42081325842541","42081325908077","42081325875309","42081325940845","42081326006381","42081325973613","42081326039149","42081326071917","42081326202989","42081326170221","42081326268525","42081326334061","42081326399597","42081393344621","42081393377389","42081393442925","42081393475693","42113158316141","42113158348909","42113158381677","42113158414445","42113158447213","42113158479981","42084892901485","42084892934253","42113158512749","42113158545517","42113158578285","42113158611053","41563697643629","42323792167021","42323792199789","41563697709165","42323791741037","41563697741933","42323792232557","41563697774701","42323792265325","41563697807469","42285996245101","42113158643821","42113158676589","42113158709357","42113158742125","42113158774893","42113158807661","42084892967021","42084892999789","42113158840429","42113158873197","42084896309357","42113107001453","42113107034221","42113107066989","42113107099757","42113107132525","42113158119533","42113158152301","42113158185069","42113158217837","42113158250605","42113158283373","42113158905965","42113158938733","42113158971501","42113159004269","42113159037037","42113159069805","42113180303469","42113180336237","42113180369005","42113180401773","42113180434541","42113180467309","42244104192109","42244104224877","42244104257645","42244104290413","42244104323181","42253192233069","42253192265837","42253192298605","42253192331373","42253199802477","42253644267629","42253644300397","42253644333165","42253644365933","42253644398701","42266840072301","42266840105069","42253269696621","42253269729389","42253269762157","42253269794925","42253269827693","42253269860461","42285886832749","42285886865517","42285886898285","42285886931053","42318282719341","42298323468397","42298323501165","42298323533933","42298323566701","42298323599469","42298323632237","42298323665005","42298323697773","42298323730541","42298323763309","42298323796077","42298323828845","42298323861613","42322825478253","42322821873773","42322821906541","42322821939309","42322821972077","42322825511021","42323795083373","42323794034797","42323794067565","42323795116141","42323795148909","42323794100333","42323794133101","42323794165869","42323794198637","42323794231405","42242160492653","42241871118445","42335405736045","42335410290797","41200359276653","42242160525421","42241871151213","42335410323565","41200359407725","42335405768813","42099115130989","41200359538797","42335410356333","42099115098221","42335405801581","41200359669869","42335410389101","42241922924653","42335405834349","42242211676269","42335410421869","42241922957421","41200359800941","42335410454637","42242211709037","42113068335213","42113090158701","41197222690925","41197222789229","42113090191469","42113110671469","42336767475821","42336767508589","42113089208429","42113109426285","41197222887533","41197222985837","42336767541357","42107056095341","42099146522733","42113090224237","42336767574125","42113110704237","41197223084141","42336767606893","42113110737005","41197223182445","42113091272813","42334512218221","40580659642477","40580659675245","40728448958573","40728448991341","40580659806317","40580659871853","40728449024109","41371482423405","42336770064493","42336770097261","42336770130029","42336770162797","41371482521709","42336770195565","42336770228333","41371482652781","41371482751085","42336770293869","42336770261101","42336770326637","41371482882157","42336770359405","42336770687085","41371483013229","42336770392173","41206647193709","42253331595373","42245497618541","42336522043501","42336522076269","42336522109037","42253331628141","42336522141805","41206647324781","42245497651309","42336522174573","42099125911661","42099125878893","42336522207341","41206647455853","42245503320173","41206647586925","42336522240109","42253331660909","42336522272877","41206647717997","42245544214637","42336522305645","42253331693677","40580698570861","42334513332333","40713275179117","40580698636397","42334513365101","40713275211885","40580698701933","42334513397869","40713275244653","40580701913197","40580701945965","42306278883437","42334512250989","40580702044269","42336716554349","42336716521581","42336719929453","42336716619885","42336716587117","42336719962221","42336719994989","42336716652653","42336716685421","42336716718189","42336720027757","42336716750957","42336716783725","42336716882029","42336720060525","42336716849261","42336720093293","42336716816493","41256325218413","42334537973869","42253644267629","42334538006637","42253644300397","42334538039405","42253644333165","42334538072173","42253644365933","42334538104941","42253644398701","42244104192109","42336279560301","42244104224877","42336279593069","42244104257645","42336279625837","42244104290413","42336279658605","42244104323181","42336279691373","42298323566701","42298323501165","42334495244397","42298323468397","42298323533933","42334496292973","42298323697773","42298323665005","42334494064749","42334495277165","42298323599469","42298323632237","42334494097517","42298323763309","42334495309933","42298323796077","42298323828845","42298323730541","42298323861613","42267082391661","42333944348781","42267082358893","42267082489965","42333944381549","42267082457197","42333944414317","42267082588269","42267082555501","42267082653805","42267082621037","42333944447085","42267082752109","42267082719341","42333944479853","42267082817645","42267082850413","42333944512621","42334528176237","42334528209005","42334528241773","42334528274541","42334528307309","42334529323117","42334526144621","42334526177389","42334526210157","42334553243757","42334553276525","42334553309293","42334551703661","42334551736429","42334551769197","42334551801965","42334595022957","42334606622829","42334595055725","42334606655597","42334595088493","42334606688365","42334595121261","42334606721133","42334595154029","42334606753901","42336283918445","42336283951213","42336283983981","42336284016749","42336284049517","42336284082285","42336284115053","42336284147821","42336284180589","42336284213357","42336284246125","42336433504365","42336433537133","42336433569901","42336433602669","42336433635437","42336442089581","42336442548333","42336442581101","42336442613869","42336450936941","42336442286189","42336442318957","42336528367725","42336525254765","42336528400493","42336528433261","42336528466029","42336528498797","42336525287533","42336528531565","42336525320301","42336528564333","42336552452205","42336552484973","42336552517741","42336552550509","42336552583277","42336552616045","42336552648813","42336552681581","42336552910957","42336552943725","42336552976493","42336553009261","42336553042029","42336553074797","42336553107565","42336553140333","42336553173101","42336553205869","42336553238637","42336553271405","42336710721645","42336710688877","42336713244781","42336710787181","42336710754413","42336713277549","42336710819949","42336713310317","42336713343085","42336713375853","42336710852717","42336713408621","42336713441389","42336713474157","42336710885485","42336713506925","42336713539693","42336710918253","42336553304173","42336553336941","42336553369709","42336553402477","42336767639661","42336767672429","42336770064493","42336770097261","42336770130029","42336770162797","42336770195565","42336770228333","42336770293869","42336770261101","42336770326637","42336770359405","42336770687085","42336770392173","42336776847469","42336767475821","42336767508589","42336767541357","42336767574125","42336767606893","42336767672429","42336796967021","42387213779053","42387213811821","42387213844589","42387213877357","42387213910125","42387213942893","42387215482989","42387215515757","42387215548525","42387215581293","42387215614061","42387215646829","42387214696557","42387214729325","42387214762093","42387214794861","42387214827629","42387214860397","41891778265197","41891778297965","42387215679597","42387215712365","42387215745133","42387214893165","42387214925933","42387214958701","42387214991469","42387215024237","42387215057005","42387215089773","42387215122541","42387215155309","42387215188077","42387215777901","42387215810669","42387215843437","42387215876205","42349188382829","42349188415597","42349410648173","42349410680941","42349410713709","42349410844781","42349416251501","42387214467181","42363977990253","42363978023021","42363978055789","42363978088557","42387214499949","42349426704493","42363973369965","42349426737261","42363973402733","42349433946221","42363973435501","42349433978989","42363973468269","42349434011757","42387214336109","42363977629805","42363977662573","42363977695341","42363977728109","42363977760877","42363977793645","42363977826413","42363977859181","42387214401645","42387214434413"]      
const springSKU = ["43310799552621","43310799519853","43310799421549","43310799618157","43310799356013","43310799683693","43310799585389","43310799487085","43310799454317","43310799650925","43310799388781","43310799716461","43310801322093","43310801289325","43310801191021","43310801387629","43310801125485","43310801453165","43310801354861","43310801256557","43310801223789","43310801420397","43310801158253","43310801485933","43311224062061","43311223996525","43311223930989","43311224127597","43311223898221","43311224193133","43311224094829","43311224029293","43311223963757","43311224160365","43311223865453","43311224225901","43323783938157","43323783872621","43323783807085","43323783970925","43323783905389","43323783839853","40580658036845","40580657971309","40580657905773","40580658102381","40580657873005","40580658167917","43292217933933","43292217901165","43292217868397","43292217966701","43292217835629","43292217999469","42387215581293","42387215548525","42387215515757","42387215614061","42387215482989","42387215646829","40506151272557","40506151239789","40506151207021","40506151305325","40506151174253","40506151338093","42387214794861","42387214762093","42387214729325","42387214827629","42387214696557","42387214860397","41830692880493","41830692749421","41830692585581","41830693011565","41830692421741","41830693142637","41830692978797","41830692847725","41830692716653","41830693109869","41830692552813","41830693240941","40580639785069","40580639653997","40580639555693","40580640079981","40580639293549","40580640243821","40582755156077","40582755123309","40582755090541","40582755188845","40582755057773","40582755221613","43288512528493","43288512561261","43288512594029","43288512626797","43288512659565","43288512692333","43288513544301","43288513577069","43288513609837","43288513642605","43288513675373","43288513708141","43318702276717","43318702243949","43318702178413","43318702342253","43318702112877","43318702407789","43318702309485","43318702211181","43318702145645","43318702375021","43318702080109","43318702440557","43288513216621","43288513249389","43288513282157","43288513314925","43288513347693","43288513380461","43318718890093","43318718824557","43318718759021","43318718955629","43318718693485","43318719021165","43318718922861","43318718857325","43318718791789","43318718988397","43318718726253","43318719053933","43292218228845","43292218196077","43292218163309","43292218261613","43292218130541","43292218294381","43288512921709","43288512954477","43288512987245","43288513020013","43288513052781","43288513085549","41834501963885","41834501996653","43302701564013","43288513118317","43288512495725","41834501963885","41834501996653","43288512430189","43302701564013","43288511971437","43288512397421","43288513151085","43288513118317","43311597158509","43311597092973","43311597125741","43311597158509","43311597191277","43311597224045","43311597256813","43288508170349","43288508203117","43288508235885","43288508268653","43288508301421","43288508760173","43288508792941","43288508825709","43288508858477","43288508891245","43288509153389","43288509186157","43288509218925","43288509251693","43288509284461","43288510857325","43288510890093","43288510922861","43288510955629","43288510988397","43288511021165","43555647324269","43555647357037","43555647389805","43555647422573","43288509677677","43288509710445","43288509743213","43288509775981","43288509808749","43288509841517","43288507580525","43288507613293","43288507646061","43288507678829","43288507711597","43288507744365","43288509349997","43288509382765","43288509415533","43288509448301","43288509481069","43288509513837","43292218032237","43288508956781","43288508989549","43288509022317","43288509055085","43288509087853","43288507383917","43288507416685","43288507449453","43288507482221","43288507514989","43288507809901","43288507908205","43288507973741","43288508039277","43288508104813","43288507777133","43288507875437","43288507940973","43288508006509","43288508072045","43288508137581","43288508399725","43288508432493","43288508498029","43288508563565","43288508629101","43288508694637","43288508366957","43288508530797","43288508596333","43288508661869","43288508727405"];
    var i1;  
    for (i1 = 0; i1 < springSKU.length; ++i1) {
       if(col_link.indexOf(springSKU[i1]) != -1){
          if($('.card__badge span',this).hasClass('ss__badge--new')){}else{
            $('.card__badge',this).append('<span class="badge badge--bottom-left color-accent-2 ss__badge--new" style="background:#2e2e2e !important;">New</span>');  
          }
       }
    }        
    
const wintersaleSKU = ["43250335514733","43250335580269","43250335547501","43258820722797","43250335678573","43250335613037","43250335645805","43258820755565","43250335776877","43250335744109","43250335711341","43250335842413","43250335809645","43258820788333","43250335875181","43250335940717","43258820821101","43250335973485","43250335907949","43250336071789","43250336039021","43250336006253","41518750957677","41518750990445","41518751023213","41518751055981","41518751088749","41518751121517","41518751154285","41518751187053","41518751219821","41518751252589","41518751285357","41518751318125","40631337386093","40590975500397","40631470063725","40631470030957","42253341753453","40631469998189","40580702994541","42336767606893","42336767541357","42336767508589","42336767475821","40580671537261","40729496584301","40729496617069","40580671209581","40580671340653","40580671504493","40580671799405","40678040600685","40678040797293","40678040862829","40678040633453","40678040830061","40678040895597","41250237939821","41250237972589","41250238005357","41250238070893","41250238103661","41250238136429","41770822205549","42336525287533","42336525320301","42336528433261","42336528498797","42336528531565","42336528564333","42113158185069","42113158217837","42113158250605","42113158283373","42113107001453","42113107034221","42113107066989","42113107099757","42113107132525","42113180303469","42113180369005","42113180401773","42113180434541","42113180467309","42387213877357","42387213910125","42387213942893","42336713244781","42336713277549","42336713375853","42336713506925","42113158316141","42113158414445","42113158479981","42084892934253","42113158545517","42113158611053","42113158348909","42113158381677","42113158447213","42084892901485","42113158512749","42113158578285","42113090158701","42113090191469","42334551703661","42334551736429","42334551769197","42334551801965","42387215843437","42387215876205","43083386355821","43083386716269","43083386781805","43083386847341","43083386388589","43083386421357","43083386486893","43083386552429","43083386617965","43083386749037","43083386814573","42349426704493","42349426737261","42349433946221","42349433978989","42349434011757","42363973369965","42363973402733","42363973435501","42363973468269","42387214336109","42363977662573","42363977728109","42363977793645","42363977859181","42387214434413","42363977629805","42363977695341","42363977760877","42363977826413","42387214401645","42253269762157","42253269860461","42334526144621","42334526177389","42334526210157","42744041439341","42744041734253","42744041635949","42744041668717","42744041799789","42742135783533","42742135685229","42742135816301","42742135849069","42742135980141","42742136111213","42244104192109","42244104224877","42244104257645","42244104290413","42244104323181","42336279560301","42336279593069","42336279625837","42336279658605","42336279691373","42336528367725","42336528400493","42336528466029","42113089208429","42113091272813","42285886832749","42285886865517","42285886898285","42285886931053","42318282719341","41256326332525","42099148193901","42099148226669","42323794100333","42323794133101","42323794165869","42323794198637","42323794231405","42336828555373","42336828588141","42336828620909","42336828653677","42336828686445","42323794034797","42323794067565","42323795116141","42323795148909","42267082358893","42267082489965","42267082588269","42267082653805","42267082850413","42367965200493","42367965954157","42367965986925","42367966380141","42367966412909","42367967756397","42333944348781","42333944381549","42333944414317","42333944447085","42333944479853","42333944512621","41474958360685","41478418497645","40580624482413","41197218824301","40580686446701","40580686577773","40580686676077","40580686741613","40580686413933","40580686545005","40580686643309","40580686708845","40580676812909","41474958491757","41489715331181","41478418235501","40506164772973","40506164740205","40506164707437","40580674060397","40580692443245","40714341711981","40714341843053","40714341318765","40580612685933","40580612882541","40580693327981","40580667244653","40580645650541","40580645683309","40580645912685","40580645978221","40580700504173","40580644962413","40506233323629","40580644241517","40580671307885","40580642340973","40506198196333","40580695556205","41593261359213","40580621664365","42267082457197","40558923776109","40558923907181","40558923972717","40558924038253","40558924103789","40558923841645","40558924169325","40558922498157","40558922563693","40678041583725","40506169524333","40506169360493","40506169426029","40506169393261","42797106888813","42797106921581","42797957808237","40713243066477","40713243033709","41246898585709","41639771570285","41639771701357","41246898716781","41639771635821","41246898651245","41246898684013","41639771668589","41639771603053","40580670161005","40580670292077","40580670423149","40580670095469","40580670357613","40580651122797","40580651155565","40580651384941","40580651450477","40580651679853","40580608065645","40580608131181","40580608295021","40580608426093","40580608491629","41200358490221","41200358555757","41200358588525","41200358719597","41256323612781","41256323711085","41256323743853","41256323776621","41256323973229","41380760387693","41256324038765","41256324071533","41256324104301","41256324137069","41256324268141","41256324497517","41256324530285","41256324595821","41256324661357","41256324726893","41200358916205","41197222789229","41197222887533","41197222985837","41197223182445","41593261490285","41593261588589","41593261719661","41593261523053","41593261686893","41593261752429","41593261817965","41593261916269","41593262014573","41593262080109","41593262145645","41593262211181","41593261949037","41593262047341","41249167704173","41249167900781","41249167933549","41249167769709","41249530085485","41249530118253","41249530151021","41197222264941","41197222330477","41197222396013","41197222461549","41197222166637","41197222232173","41197222297709","41197222363245","42931316260973","42931316326509","42931316392045","41256325283949","41256325906541","41256325677165","41256325939309","41256326299757","41250570502253","41250570567789","41250570633325","41250570797165","41250570961005","40620904743021","41256326430829","41256326463597","41197218693229","40968003944557","40968004042861","40968004108397","40968004239469","40968004305005","40968003977325","40968004010093","40968004075629","40968004206701","40968004272237","40580636573805","40580685070445","40580685693037"];   
    var w1;  
    for (w1 = 0; w1 < wintersaleSKU.length; ++w1) {
       if(col_link.indexOf(wintersaleSKU[w1]) != -1){
          if($('.card__badge span',this).hasClass('ss__badge--sale')){
            $('.card__badge .ss__badge--sale',this).attr('style', 'background-color:#fce072 !important');
            $('.card__badge .ss__badge--sale',this).attr('style', 'background-color:#fce072 !important;color:#000 !important');
            $('.card__badge .ss__badge--sale',this).html('EOS Sale');
          }
       }
    } 

//POSSUM CUSTOM BADGE         
//}     
    
    });  

    $('.ss__pagination__page a').click(function(){
      
      setTimeout(function() {
      if($('body').hasClass('template-collection-outlet')){
        //$('.card__badge .ss__badge--sale').html('CLEARANCE OUTLET');
        $('.card__badge .ss__badge--sale').addClass('badge-clearance-outlet');
        $('.card__badge .ss__badge--sale').attr('style', 'background-color:#BB252A !important');           
      }      
      }, 1000);   

    });
    
  }, 3000);    

  //https://creswickwool.com/account/login?return_url=%2Fpages%2Ftest-subscriber-page

  $('#rich-text-115653194 p a').click(function(){
    $('.kl-private-reset-css-Xuajs1 .klaviyo-close-form').click();  
  });

$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    //console.log("Scroll: "+scroll);
if (window.matchMedia("(max-width: 767px)").matches)
{
    if (scroll >= 850) {
        $(".template-product").addClass("product-scrolled");
    } else {
        $(".template-product").removeClass("product-scrolled");
    }

    if (scroll < (1700+($('.cart-items').height()))) {
        $(".template-cart").addClass("cart-scrolled");
    } else {
      $(".template-cart").removeClass("cart-scrolled");
    }
  
    //if (scroll >= 1600) {
       // $(".template-cart").addClass("cart-scrolled");
    //} else {
      //$(".template-cart").removeClass("cart-scrolled");
    //}
  
}

//CHECK FOR SCROLLING TO UPDATE
    $('.ss__result--item').each(function(){

      //if($('body').hasClass('col-new-winter-accessories') || $('body').hasClass('col-new-winter-2025') || $('body').hasClass('col-womens-winter-clothing') || $('body').hasClass('col-new-winter-unique-2025') || $('body').hasClass('col-new-winter-mens-clothing')){
        //if($('.card__badge span',this).hasClass('ss__badge--new')){}else{
          //$('.card__badge',this).append('<span class="badge badge--bottom-left color-accent-2 ss__badge--new" style="background:rgb(56, 66, 47) !important;">New</span>');  
        //}
      //}      

    var col_link = $('.card__content .main-prod-card-link',this).attr('href');  
      if($('.card__badge span',this).hasClass('ss__badge--sale')){
          $('.card__badge .ss__badge--new',this).hide();
      }      
      
const wintersaleSKU = ["43250335514733","43250335580269","43250335547501","43258820722797","43250335678573","43250335613037","43250335645805","43258820755565","43250335776877","43250335744109","43250335711341","43250335842413","43250335809645","43258820788333","43250335875181","43250335940717","43258820821101","43250335973485","43250335907949","43250336071789","43250336039021","43250336006253","41518750957677","41518750990445","41518751023213","41518751055981","41518751088749","41518751121517","41518751154285","41518751187053","41518751219821","41518751252589","41518751285357","41518751318125","40631337386093","40590975500397","40631470063725","40631470030957","42253341753453","40631469998189","40580702994541","42336767606893","42336767541357","42336767508589","42336767475821","40580671537261","40729496584301","40729496617069","40580671209581","40580671340653","40580671504493","40580671799405","40678040600685","40678040797293","40678040862829","40678040633453","40678040830061","40678040895597","41250237939821","41250237972589","41250238005357","41250238070893","41250238103661","41250238136429","41770822205549","42336525287533","42336525320301","42336528433261","42336528498797","42336528531565","42336528564333","42113158185069","42113158217837","42113158250605","42113158283373","42113107001453","42113107034221","42113107066989","42113107099757","42113107132525","42113180303469","42113180369005","42113180401773","42113180434541","42113180467309","42387213877357","42387213910125","42387213942893","42336713244781","42336713277549","42336713375853","42336713506925","42113158316141","42113158414445","42113158479981","42084892934253","42113158545517","42113158611053","42113158348909","42113158381677","42113158447213","42084892901485","42113158512749","42113158578285","42113090158701","42113090191469","42334551703661","42334551736429","42334551769197","42334551801965","42387215843437","42387215876205","43083386355821","43083386716269","43083386781805","43083386847341","43083386388589","43083386421357","43083386486893","43083386552429","43083386617965","43083386749037","43083386814573","42349426704493","42349426737261","42349433946221","42349433978989","42349434011757","42363973369965","42363973402733","42363973435501","42363973468269","42387214336109","42363977662573","42363977728109","42363977793645","42363977859181","42387214434413","42363977629805","42363977695341","42363977760877","42363977826413","42387214401645","42253269762157","42253269860461","42334526144621","42334526177389","42334526210157","42744041439341","42744041734253","42744041635949","42744041668717","42744041799789","42742135783533","42742135685229","42742135816301","42742135849069","42742135980141","42742136111213","42244104192109","42244104224877","42244104257645","42244104290413","42244104323181","42336279560301","42336279593069","42336279625837","42336279658605","42336279691373","42336528367725","42336528400493","42336528466029","42113089208429","42113091272813","42285886832749","42285886865517","42285886898285","42285886931053","42318282719341","41256326332525","42099148193901","42099148226669","42323794100333","42323794133101","42323794165869","42323794198637","42323794231405","42336828555373","42336828588141","42336828620909","42336828653677","42336828686445","42323794034797","42323794067565","42323795116141","42323795148909","42267082358893","42267082489965","42267082588269","42267082653805","42267082850413","42367965200493","42367965954157","42367965986925","42367966380141","42367966412909","42367967756397","42333944348781","42333944381549","42333944414317","42333944447085","42333944479853","42333944512621","41474958360685","41478418497645","40580624482413","41197218824301","40580686446701","40580686577773","40580686676077","40580686741613","40580686413933","40580686545005","40580686643309","40580686708845","40580676812909","41474958491757","41489715331181","41478418235501","40506164772973","40506164740205","40506164707437","40580674060397","40580692443245","40714341711981","40714341843053","40714341318765","40580612685933","40580612882541","40580693327981","40580667244653","40580645650541","40580645683309","40580645912685","40580645978221","40580700504173","40580644962413","40506233323629","40580644241517","40580671307885","40580642340973","40506198196333","40580695556205","41593261359213","40580621664365","42267082457197","40558923776109","40558923907181","40558923972717","40558924038253","40558924103789","40558923841645","40558924169325","40558922498157","40558922563693","40678041583725","40506169524333","40506169360493","40506169426029","40506169393261","42797106888813","42797106921581","42797957808237","40713243066477","40713243033709","41246898585709","41639771570285","41639771701357","41246898716781","41639771635821","41246898651245","41246898684013","41639771668589","41639771603053","40580670161005","40580670292077","40580670423149","40580670095469","40580670357613","40580651122797","40580651155565","40580651384941","40580651450477","40580651679853","40580608065645","40580608131181","40580608295021","40580608426093","40580608491629","41200358490221","41200358555757","41200358588525","41200358719597","41256323612781","41256323711085","41256323743853","41256323776621","41256323973229","41380760387693","41256324038765","41256324071533","41256324104301","41256324137069","41256324268141","41256324497517","41256324530285","41256324595821","41256324661357","41256324726893","41200358916205","41197222789229","41197222887533","41197222985837","41197223182445","41593261490285","41593261588589","41593261719661","41593261523053","41593261686893","41593261752429","41593261817965","41593261916269","41593262014573","41593262080109","41593262145645","41593262211181","41593261949037","41593262047341","41249167704173","41249167900781","41249167933549","41249167769709","41249530085485","41249530118253","41249530151021","41197222264941","41197222330477","41197222396013","41197222461549","41197222166637","41197222232173","41197222297709","41197222363245","42931316260973","42931316326509","42931316392045","41256325283949","41256325906541","41256325677165","41256325939309","41256326299757","41250570502253","41250570567789","41250570633325","41250570797165","41250570961005","40620904743021","41256326430829","41256326463597","41197218693229","40968003944557","40968004042861","40968004108397","40968004239469","40968004305005","40968003977325","40968004010093","40968004075629","40968004206701","40968004272237","40580636573805","40580685070445","40580685693037"];   
    var w1;  
    for (w1 = 0; w1 < wintersaleSKU.length; ++w1) {
       if(col_link.indexOf(wintersaleSKU[w1]) != -1){
          if($('.card__badge span',this).hasClass('ss__badge--sale')){
            $('.card__badge .ss__badge--sale',this).attr('style', 'background-color:#fce072 !important');
            $('.card__badge .ss__badge--sale',this).attr('style', 'background-color:#fce072 !important;color:#000 !important');
            $('.card__badge .ss__badge--sale',this).html('EOS Sale');
          }
       }
    }

//POSSUM CUSTOM BADGE    
     
//}        
    var multiTitle = $('.ss__result__name',this).text();
    var packMessage="";  
      
        if (multiTitle.indexOf('2 Pack') !== -1) {
          packMessage ='2 Pack';
        }
        if (multiTitle.indexOf('3 Pack') !== -1) {
          packMessage ='3 Pack';
        }
        if (multiTitle.indexOf('4 Pack') !== -1) {
          packMessage ='4 Pack';
        }
        if (multiTitle.indexOf('10 Pack') !== -1) {
          packMessage ='10 Pack';
        }
        if (multiTitle.indexOf('12 Pack') !== -1) {
          packMessage ='12 Pack';
        }      
        //console.log('Pack Message: '+packMessage);
          if(packMessage !=''){
            if($('.card__content .main-prod-card-link',this).find('.card-multi-badge').length !== 0){}else{
              $('.card__content .main-prod-card-link',this).append('<div class="card__badge bottom right ss__badge__container card-multi-badge"><span class="multi-badge badge">'+packMessage+'</span>');
          }
        } 

const springSKU = ["43310799552621","43310799519853","43310799421549","43310799618157","43310799356013","43310799683693","43310799585389","43310799487085","43310799454317","43310799650925","43310799388781","43310799716461","43310801322093","43310801289325","43310801191021","43310801387629","43310801125485","43310801453165","43310801354861","43310801256557","43310801223789","43310801420397","43310801158253","43310801485933","43311224062061","43311223996525","43311223930989","43311224127597","43311223898221","43311224193133","43311224094829","43311224029293","43311223963757","43311224160365","43311223865453","43311224225901","43323783938157","43323783872621","43323783807085","43323783970925","43323783905389","43323783839853","40580658036845","40580657971309","40580657905773","40580658102381","40580657873005","40580658167917","43292217933933","43292217901165","43292217868397","43292217966701","43292217835629","43292217999469","42387215581293","42387215548525","42387215515757","42387215614061","42387215482989","42387215646829","40506151272557","40506151239789","40506151207021","40506151305325","40506151174253","40506151338093","42387214794861","42387214762093","42387214729325","42387214827629","42387214696557","42387214860397","41830692880493","41830692749421","41830692585581","41830693011565","41830692421741","41830693142637","41830692978797","41830692847725","41830692716653","41830693109869","41830692552813","41830693240941","40580639785069","40580639653997","40580639555693","40580640079981","40580639293549","40580640243821","40582755156077","40582755123309","40582755090541","40582755188845","40582755057773","40582755221613","43288512528493","43288512561261","43288512594029","43288512626797","43288512659565","43288512692333","43288513544301","43288513577069","43288513609837","43288513642605","43288513675373","43288513708141","43318702276717","43318702243949","43318702178413","43318702342253","43318702112877","43318702407789","43318702309485","43318702211181","43318702145645","43318702375021","43318702080109","43318702440557","43288513216621","43288513249389","43288513282157","43288513314925","43288513347693","43288513380461","43318718890093","43318718824557","43318718759021","43318718955629","43318718693485","43318719021165","43318718922861","43318718857325","43318718791789","43318718988397","43318718726253","43318719053933","43292218228845","43292218196077","43292218163309","43292218261613","43292218130541","43292218294381","43288512921709","43288512954477","43288512987245","43288513020013","43288513052781","43288513085549","41834501963885","41834501996653","43302701564013","43288513118317","43288512495725","41834501963885","41834501996653","43288512430189","43302701564013","43288511971437","43288512397421","43288513151085","43288513118317","43311597158509","43311597092973","43311597125741","43311597158509","43311597191277","43311597224045","43311597256813","43288508170349","43288508203117","43288508235885","43288508268653","43288508301421","43288508760173","43288508792941","43288508825709","43288508858477","43288508891245","43288509153389","43288509186157","43288509218925","43288509251693","43288509284461","43288510857325","43288510890093","43288510922861","43288510955629","43288510988397","43288511021165","43555647324269","43555647357037","43555647389805","43555647422573","43288509677677","43288509710445","43288509743213","43288509775981","43288509808749","43288509841517","43288507580525","43288507613293","43288507646061","43288507678829","43288507711597","43288507744365","43288509349997","43288509382765","43288509415533","43288509448301","43288509481069","43288509513837","43292218032237","43288508956781","43288508989549","43288509022317","43288509055085","43288509087853","43288507383917","43288507416685","43288507449453","43288507482221","43288507514989","43288507809901","43288507908205","43288507973741","43288508039277","43288508104813","43288507777133","43288507875437","43288507940973","43288508006509","43288508072045","43288508137581","43288508399725","43288508432493","43288508498029","43288508563565","43288508629101","43288508694637","43288508366957","43288508530797","43288508596333","43288508661869","43288508727405"];
    var i1;  
    for (i1 = 0; i1 < springSKU.length; ++i1) {
       if(col_link.indexOf(springSKU[i1]) != -1){
          if($('.card__badge span',this).hasClass('ss__badge--new')){}else{
            $('.card__badge',this).append('<span class="badge badge--bottom-left color-accent-2 ss__badge--new" style="background:#2e2e2e !important;">New</span>');  
          }
       }
    }      

      //OVERRIDE FOR FROM IN PRODUCT CARD
      
      //let originalText = $(".price__container .price-item--last",this).text();
      //if (originalText.toLowerCase().includes("from")){      
        //$(".price__container .price-item--last",this).html('');
        //$(".price__container .price-item--last",this).empty();
        //let cleanedText = originalText.replace(/from/gi, "");
        //$(".price__container .price-item--last",this).html(cleanedText);         

        //let text = $(".price__container .price-item--last",this).text(); // Get text from the div
        
        // Split into words, filter out duplicates, and join back
        //let uniqueWords = text.split(" ").filter((word, index, self) => self.indexOf(word) === index).join(" ");
        //$(".price__container .price-item--last",this).text(uniqueWords); // Set the cleaned text back to the div
        
      //}      
    
    });  
  
});

$('.prod-clearance-btn').click(function(e){
  e.preventDefault();
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'VH4SL6']);  
});

/* CUSTOM CODE */
setTimeout(function() {
    
$('.needsclick.go1515943218').html('Receive $20 Off');

$('.needsclick.go1515943218').click(function(){
    $('.needsclick.go1515943218').html('Receive $20 Off');
});
$('#email_105192842').keyup(function(){
    $('.needsclick.go1515943218').html('Receive $20 Off');
});

$('#rich-text-105192848 p span').html('Welcome20 Discount Code can only be used once in one transaction and cannot be used in conjunction with any other offer or Discount Code.');
$('#rich-text-105192848 p span').text('Welcome20 Discount Code can only be used once in one transaction and cannot be used in conjunction with any other offer or Discount Code.');
$('#rich-text-105192846 div:nth-child(2)').hide();
var wishURL = window.location;
//$('.register-popup-h3').html('<a href="/account/login">Already a Member? Log In </a>');
if(wishURL == 'https://creswickwool.com/pages/wishlist'){
  $('.reg-variable-text').html('Save your Wishlist by entering your details below!');
}else{
  $('.reg-variable-text').html('Become a Member and <br>receive $20 Off');  
}  

    const mouseEvent = e => {
      if (!e.toElement && !e.relatedTarget) {
            document.removeEventListener('mouseout', mouseEvent);
        if(Cookies.get('exit-cookie')){
            if(wishURL == 'https://creswickwool.com/pages/wishlist'){
              $('.reg-variable-text').html('Save your Wishlist by entering your details below!');
            }else{
              $('.reg-variable-text').html('Become a Member and <br>receive $20 Off');  
            }  
        }                          
      }
    };
    document.addEventListener('mouseout', mouseEvent); 

    $('.register-popup-btn').click(function(){
          if(wishURL == 'https://creswickwool.com/pages/wishlist'){
              $('.reg-variable-text').html('Save your Wishlist by entering your details below!');
            }else{
              $('.reg-variable-text').html('Become a Member and <br>receive $20 Off');  
            }          
    });  

}, 3000);

  //$('.cart-cs-message .add-customer-text p').text('Trusted 5 Star Natural Fibre Experts');
  $('.not-logged-in .cart-cs-message a:first-child').click(function(e){
    e.preventDefault();
    $('.register-popup-overlay').css('display','block');
    $('.register-popup-overlay').css('visibility','visible');
    $('.register-popup-overlay').css('opacity','1');      
  });
  $('.not-logged-in .cart-cs-message a:last-child').click(function(e){
    e.preventDefault();
    $('.login-overlay').css('display','block');
    $('.login-overlay').css('visibility','visible');
    $('.login-overlay').css('opacity','1');      
  });

  //UPSELL PRICE TOTAL UPDATE
  var qtyVal = $('.upsell-botanical-bug-buster-40 .upsell-item__qty .quantity__input').val();
  var upsellPrice = $('.upsell-botanical-bug-buster-40 .upsell-price').attr('data-price');
  var upsellTotal = (upsellPrice * qtyVal).toFixed(2);
  $('.upsell-botanical-bug-buster-40 .upsell-total').html('$'+upsellTotal);

  $('.upsell-botanical-bug-buster-40 .upsell-item__qty .quantity__button').click(function(){
    qtyVal = $('.upsell-botanical-bug-buster-40 .upsell-item__qty .quantity__input').val();
    upsellTotal = (upsellPrice * qtyVal).toFixed(2);
    $('.upsell-botanical-bug-buster-40 .upsell-total').html('$'+upsellTotal);
  });

  //UPSELL PRICE TOTAL UPDATE
  var qtyVal_2 = $('.upsell-water-resistance-picnic-rug-check .upsell-item__qty .quantity__input').val();
  var upsellPrice_2 = $('.upsell-water-resistance-picnic-rug-check .upsell-price').attr('data-price');
  console.log('QTY2: '+qtyVal_2);
  var upsellTotal_2 = (upsellPrice_2 * qtyVal_2).toFixed(2);
  $('.upsell-water-resistance-picnic-rug-check .upsell-total').html('$'+upsellTotal_2);

  $('.upsell-water-resistance-picnic-rug-check .upsell-item__qty .quantity__button').click(function(){
    qtyVal_2 = $('.upsell-water-resistance-picnic-rug-check .upsell-item__qty .quantity__input').val();
    upsellTotal_2 = (upsellPrice_2 * qtyVal_2).toFixed(2);
    $('.upsell-water-resistance-picnic-rug-check .upsell-total').html('$'+upsellTotal_2);
  }); 
});

// Using the onload event handler property
window.onload = (event) => {
// YOTPO REWARDS OVERRIDE
setTimeout(function() {  
  $(document).on('click','.yotpo-action-button-widget .yotpo-button-style', function(){
    console.log('button click');
    setTimeout(function() {
    $('.yotpo-rewards-history-tile .yotpo-grid-row').each(function(){
      var inner_Text = $('.row-action-column .yotpo-inner-text',this).text();
      console.log('REWARD_TEXT: '+inner_Text);
      if(inner_Text.indexOf('Welcome to Merino Bronze') != -1){
        $('.yotpo-copy-code-button',this).addClass('tier-reward-code');
      }else{
        $('.yotpo-copy-code-button',this).addClass('default-reward-code');
      }
      var discountCode = $('.row-status-column .yotpo-inner-text',this).text();
      $('.yotpo-copy-code-button',this).click(function(){
        console.log(discountCode);
        var discountURL = 'https://creswickwool.com/discount/'+discountCode;
        console.log(discountURL);
        $.ajax({
          url:discountURL,
          success: function(data) {
            console.log("Your discount has been applied!");
          }
        });         
      });
      $('.tier-reward-code',this).click(function(){
        alert('Select OK/Close to automatically place this discount code into your cart, which applies for orders over $100.');
          if(window.location.pathname == '/cart'){
            window.location.href = "https://creswickwool.com/cart";  
          }
      });
      $('.default-reward-code',this).click(function(){
        alert('Select OK/Close to automatically place Discount Code into cart.');
          if(window.location.pathname == '/cart'){
            window.location.href = "https://creswickwool.com/cart";  
          }
      });      
    });
    }, 2000);          
  });  

// discount field
      $('.cart-discount-form').click(function(e){
        e.preventDefault();
        var dCode = $('.cart-discount-text').val();
        if(dCode != ''){
          var dCodeURL = 'https://creswickwool.com/discount/'+dCode;  
          console.log(dCodeURL);
          $.ajax({
            url:dCodeURL,
            success: function(data) {
              console.log("Your discount has been applied!");
              window.location.href = "https://creswickwool.com/cart";
            }
          });          
        }
        
        
         
      });  
  
  //$('.ss__badge--australian-made img').attr('src','https://cdn.shopify.com/s/files/1/0559/9825/1117/files/au_made_c962b8f6-7fab-43b9-9aa5-49b7fd1d9776.webp?v=1726112641');
    }, 3000);       
  //$('.ss__badge--australian-made img').attr('src','https://cdn.shopify.com/s/files/1/0559/9825/1117/files/au_made_c962b8f6-7fab-43b9-9aa5-49b7fd1d9776.webp?v=1726112641');

var wishURL = window.location;  
  if(wishURL == 'https://creswickwool.com/pages/wishlist'){
    if($('body').hasClass('not-logged-in')){
      if(Cookies.get('wishlist-cookie')){
        $('.register-popup-overlay').css('display','none');        
      }      
      else{
        $('.register-popup-overlay').css('display','block');
        $('.register-popup-overlay').css('visibility','visible');
        $('.register-popup-overlay').css('opacity','1'); 
      }       
    }
  }

const videoLinks = document.querySelectorAll('.video-link');
const videoPopup = document.getElementById('videoPopup');
const videoFrame = document.getElementById('videoFrame');
const closeButton = document.querySelector('.video-close');

videoLinks.forEach(link => {
    link.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent default link behavior
        const videoId = this.getAttribute('data-video-id');
        videoFrame.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`; // Set video src to autoplay
        videoPopup.style.display = 'block'; // Show the popup
    });
});
if(closeButton != undefined){
  closeButton.addEventListener('click', function() {
      videoPopup.style.display = 'none'; // Hide the popup
      videoFrame.src = ''; // Stop the video when closing
  });
}   

window.addEventListener('click', function(event) {
    if (event.target === videoPopup) {
        videoPopup.style.display = 'none'; // Hide the popup if clicking outside
        videoFrame.src = ''; // Stop the video
    }
});  

  $('.recover-pword').click(function(){
    $('.recover-form').show();
    $('#customer_login').hide();
    $('h1#login').hide();
    $('h2#login').hide();
  });  


    $('.ss__pagination__page').click(function(){
      
        console.log('pagination clicked');
        setTimeout(function() {
      console.log('timeout set');
      $('.template-collection .ss__result').each(function(){
        $('.ss__badge--australian-made img',this).attr('src','https://cdn.shopify.com/s/files/1/0559/9825/1117/files/au_made_c962b8f6-7fab-43b9-9aa5-49b7fd1d9776.webp?v=1726112641');
      var multiTitle = $('.ss__result__name',this).text();          
        if (multiTitle.indexOf('2 Pack') !== -1) {
              $('.card__content .main-prod-card-link',this).append('<div class="card__badge bottom right ss__badge__container card-multi-badge"><span class="multi-badge badge">'+packMessage+'</span>');
        }
        if (multiTitle.indexOf('3 Pack') !== -1) {
              $('.card__content .main-prod-card-link',this).append('<div class="card__badge bottom right ss__badge__container card-multi-badge"><span class="multi-badge badge">'+packMessage+'</span>');
        }
        if (multiTitle.indexOf('4 Pack') !== -1) {
              $('.card__content .main-prod-card-link',this).append('<div class="card__badge bottom right ss__badge__container card-multi-badge"><span class="multi-badge badge">'+packMessage+'</span>');
        }
        if (multiTitle.indexOf('10 Pack') !== -1) {
              $('.card__content .main-prod-card-link',this).append('<div class="card__badge bottom right ss__badge__container card-multi-badge"><span class="multi-badge badge">'+packMessage+'</span>');
        }         
      });
      }, 1000);
     
    });

  $('.infiniteoptions-price').appendTo('.infinite-container');
  $('.infiniteoptions-price').prepend('<span>Bed Ensemble Total Price</span>');



  if($('.product__info-container').find('.yotpo-widget-instance').length !== 0){

    var textReview = $('.yotpo-reviews-carousel-widget-clear .glide__slides .glide__slide:first-child .review-content').text().trim();
    console.log('Review Text: '+textReview);
    if(textReview != ''){
      $('.review-snippet').show();
    }
    $('.review-snippet span').html(String(textReview.substr(0,75)+'...'));
  }


  //template-product-base-bedheads
  //template-product-mattress

    $('.ss__load-more').click(function(){
      
        console.log('pagination clicked');
        setTimeout(function() {
      console.log('timeout set');
      $('.template-collection .ss__result').each(function(){
        $('.ss__badge--australian-made img',this).attr('src','https://cdn.shopify.com/s/files/1/0559/9825/1117/files/au_made_c962b8f6-7fab-43b9-9aa5-49b7fd1d9776.webp?v=1726112641');
        var multiTitle = $('.ss__result__name',this).text();  
        var packMessage='';
        if (multiTitle.indexOf('2 Pack') !== -1) {
          packMessage ='2 Pack';
        }
        if (multiTitle.indexOf('3 Pack') !== -1) {
          packMessage ='3 Pack';
        }
        if (multiTitle.indexOf('4 Pack') !== -1) {
          packMessage ='4 Pack';
        }
        if (multiTitle.indexOf('10 Pack') !== -1) {
          packMessage ='10 Pack';
        } 
        
          if(packMessage !=''){
            if($('.card__badge',this).find('.multi-badge').length !== 0){}else{
              //$('.card__badge',this).append('<span class="multi-badge badge">'+packMessage+'</span>');  
          }
        } 

      $('.ss__badge__container span',this).each(function(){
          console.log('THIS: '+$(this).attr('class'));
          if($(this).hasClass('ss__badge--sale')){
            
            $(this).siblings('.ss__badge--new').hide();
          }
      });        
        
      });

      //if($('body').hasClass('template-collection-mattresses')){
        //$('.ss__badge--sale').html('40% Off!');
      //}    

          
      }, 1000);
     
    });
  

    setTimeout(function() {
      if($('.product__info-container').find('.yotpo-widget-instance').length !== 0){
        
        var textReview = $('.yotpo-reviews-carousel-widget-clear .glide__slides .glide__slide:first-child .review-content').text().trim();
        console.log('Review Text: '+textReview);
        if(textReview != ''){
          $('.review-snippet span').html(String(textReview.substr(0,65)+'...'));
          $('.review-snippet').show();  
        }
        
      }
  }, 1000);  
  
};

  if($('body').hasClass('template-product-base-bedheads') || $('body').hasClass('template-product-mattress')){
    var pathArray = window.location.pathname.split( '/' );
    if(pathArray.includes('collections')){
      let currentUrl = window.location.href;
      let startMarker = 'collections';
      let endMarker = 'products';
      let newUrl = currentUrl.replace(new RegExp(startMarker + '.*?' + endMarker, 'g'), 'products');
      window.location.href = newUrl;      
    }    
  }

//document.querySelector('#is-gift').addEventListener('change', function() { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Is this a gift?': this.checked ? 'Yes' : 'No' } }) }); });
$('.lusso-text-snippet a').click(function(){
  $('#lusso-product-description .morelink').click();  
});

$("div[id*='wishlist_engine_product_page_RFmFKW']").appendTo('.template-product-mattress .product-form__buttons');
$("div[id*='wishlist_engine_product_page_B3tBM7']").appendTo('.template-product-lusso-mattress .product-form__buttons');
$("div[id*='wishlist_engine_product_page_xNNWjL']").appendTo('.template-product-base-bedheads .product-form__buttons');

document.addEventListener('DOMContentLoaded', function () {
  // Get the "More" links
  const moreLinks = document.querySelectorAll('.size-guide-popuplink');
  const contLink = document.querySelectorAll('.prod-contact-btn');
  const popup = document.getElementById('product-popup');
  const closeBtn = document.querySelector('.popup-close');
  const productDescription = document.getElementById('product-description');

  $('.size-guide-popuplink').click(function(event){
    event.preventDefault();
    $('.default-size-guide').show();
    $('.product-contact-popup').hide();
    popup.style.display = 'flex';  // Show the popup    
  });  
  $('.prod-contact-btn').click(function(event){
    event.preventDefault();
    $('.default-size-guide').hide();
    $('.product-contact-popup').show();
    popup.style.display = 'flex';  // Show the popup    
  });    

  // Close the popup
  if(closeBtn != null){
    closeBtn.addEventListener('click', function () {
      popup.style.display = 'none';
      $('.default-size-guide').hide();
      $('.product-contact-popup').hide();
    });    
  }


  // Close the popup when clicking outside of it
  window.addEventListener('click', function (event) {
    if (event.target === popup) {
      popup.style.display = 'none';
      $('.default-size-guide').hide();
      $('.product-contact-popup').hide();
    }
  });

      //$('.template-product-essential .quick-add-modal__content .icon-close').on('click', function (e) {
      //location.reload();
    //});
});


  //MATRESS SHOW BUTTONS AFTER   
  window.addEventListener('load', function () {
    // Show product buttons after everything is fully loaded
    setTimeout(function() {
      $('.template-product-mattress .product-form-buy').show();
      $('.template-product-lusso-mattress .product-form-buy').show();
      $('.template-product-base-bedheads .product-form-buy').show();
    }, 1500); 
  });

  $('.bed-product .product-form__buttons .product-form__submit').prop('disabled', true);

  const postcodeInput = document.getElementById("inputField");
  const submitButton = document.getElementById("mattressbedSubmit");

    // Function to toggle button
  if(postcodeInput != null){
    postcodeInput.addEventListener("input", () => {
      if (postcodeInput.value.trim() !== "") {
        $('.bed-product .product-form__buttons .product-form__submit').prop('disabled', false);
      } else {
        $('.bed-product .product-form__buttons .product-form__submit').prop('disabled', true);
      }
    });
  }  

     //POSSUM CODE 
$(document).on('click', '#possum-signin', function(e) {
  e.preventDefault();
  $('.subscribe-popup-overlay').hide();
  $('.possum-popup-overlay')
    .css({
      'display': 'block',
      'visibility': 'visible',
      'opacity': '1'
    });
});    
$(document).on('click', '#possum-signin-drawer', function(e) {
  e.preventDefault();
  $('.subscribe-popup-overlay').hide();
  $('.possum-popup-overlay')
    .css({
      'display': 'block',
      'visibility': 'visible',
      'opacity': '1'
    });
}); 

$(document).on('click', '#select-gloves-drawer', function(e) {
  e.preventDefault();
  $('.subscribe-popup-overlay').hide();
  $('#free-gloves-modal').show();
}); 

    
$(document).on('click', 'form[action*="/cart/add"] [type="submit"]', function (e) {
  // Check if the clicked button has the class
  if ($(this).hasClass('possum-buy-button')) {
    $('.subscribe-popup-overlay').hide();
    $('.logged-in #free-gloves-modal').show();
    $('.possum-popup-overlay')
      .css({
        'display': 'block',
        'visibility': 'visible',
        'opacity': '1'
      });
  }
});


(function () {
  // Inject styles once
  function ensurePopupStyles() {
    if (document.getElementById('possum-popup-styles')) return;
    const style = document.createElement('style');
    style.id = 'possum-popup-styles';
    style.textContent = `
      .possum-modal-overlay {
        position: fixed; inset: 0; display: flex; align-items: center; justify-content: center;
        background: rgba(0,0,0,0.5); z-index: 99999; opacity: 0; pointer-events: none;
        transition: opacity .2s ease;
      }
      .possum-modal-overlay.is-open { opacity: 1; pointer-events: auto; }
      .possum-modal {
        width: 90%; max-width: 350px; background: rgb(187, 37, 42); color: #fff;
        border-radius: 10px; padding: 20px; text-align: center; box-shadow: 0 10px 30px rgba(0,0,0,.35);
        font-family: Arial, Helvetica, sans-serif;
      }
      .possum-modal h2 { margin: 0 0 12px; font-size: 18px; font-weight: 700; letter-spacing: .02em; }
      .possum-modal p { margin: 0 0 18px; line-height: 1.45; font-size: 14px; }
      .possum-modal .possum-close-btn {
        display: inline-block; border: 0; border-radius: 6px; padding: 10px 16px; cursor: pointer;
        background: #fff; color: rgb(187, 37, 42); font-weight: 700; font-size: 14px;
      }
      .possum-modal .possum-close-btn:focus { outline: 2px solid #fff; outline-offset: 2px; }
    `;
    document.head.appendChild(style);
  }

  function buildPopup() {
    ensurePopupStyles();

    // Remove existing instance if any
    const existing = document.getElementById('possum-modal-overlay');
    if (existing) existing.remove();

    const overlay = document.createElement('div');
    overlay.id = 'possum-modal-overlay';
    overlay.className = 'possum-modal-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML = `
      <div class="possum-modal" role="document">
        <h2>MEMBER OFFER</h2>
        <p>
          Your gloves have been added to your Cart.<br><br>
          Please close this window to select and add your Possum Item to Cart which will activate your Free Gloves* Discount Offer in your Cart.
        </p>
        <button type="button" class="possum-close-btn">Close</button>
      </div>
    `;

    document.body.appendChild(overlay);
    // small async tick for transition
    requestAnimationFrame(() => overlay.classList.add('is-open'));

    function close() {
      overlay.classList.remove('is-open');
      setTimeout(() => overlay.remove(), 200);
    }

    // Close on button
    overlay.querySelector('.possum-close-btn').addEventListener('click', close);
    // Close when clicking dim background
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
    });

    return overlay;
  }

  // Show popup (call after the button action you care about)
  function showPopup(e) {
    //if (e) e.preventDefault(); // stop form submits or default button actions
    setTimeout(function() {
      $('#free-gloves-modal').hide();
      buildPopup();
    }, 2000);     

  }

  // 1) Handle direct clicks on the button (works even if added later)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.possum-promo-gloves-container button');
    if (btn) {
      showPopup(e);
    }
  });

  // 2) Handle form submits where that button is the submitter
  document.addEventListener('submit', function (e) {
    // e.submitter is widely supported (incl. modern Firefox/Chrome)
    const submitter = e.submitter || document.activeElement;
    if (submitter && submitter.closest('.possum-promo-gloves-container')) {
      showPopup(e);
    }
  });
})();


//Append Badge to multicolumn
$('#home-new-arrival .home-col-links').each(function(){
    $(this).append('<span class="home-new-arrival-badge">New</span>');
});
$('.home-natural-fibres .rich-text__text p a:first-child').addClass('active-column');
$("[id*='multicolumn_9rLBFU']").addClass('active-grid-column');
$('.home-natural-fibres .rich-text__text p a').click(function(e){
  e.preventDefault();
  var getTitle = $(this).attr('title');
  console.log(getTitle);
  $('.home-natural-fibres .rich-text__text p a').removeClass('active-column');
  $(this).addClass('active-column');
  if(getTitle == '#new-arrivals'){
    $("[id*='multicolumn_N4mifK']").addClass('active-grid-column');  
    $("[id*='multicolumn_9rLBFU']").removeClass('active-grid-column');
    $("[id*='multicolumn_3tmAAU']").removeClass('active-grid-column');
    $("[id*='multicolumn_qjBmmM']").removeClass('active-grid-column');
  }
  if(getTitle == '#monthly-offers'){
    $("[id*='multicolumn_N4mifK']").removeClass('active-grid-column');
    $("[id*='multicolumn_9rLBFU']").addClass('active-grid-column');  
    $("[id*='multicolumn_3tmAAU']").removeClass('active-grid-column');
    $("[id*='multicolumn_qjBmmM']").removeClass('active-grid-column');
  }
  if(getTitle == '#end-of-season-sale'){
    $("[id*='multicolumn_N4mifK']").removeClass('active-grid-column');
    $("[id*='multicolumn_9rLBFU']").removeClass('active-grid-column');  
    $("[id*='multicolumn_qjBmmM']").addClass('active-grid-column');  
    $("[id*='multicolumn_3tmAAU']").removeClass('active-grid-column');
  }  
  if(getTitle == '#sale-items'){
    $("[id*='multicolumn_N4mifK']").removeClass('active-grid-column');
    $("[id*='multicolumn_9rLBFU']").removeClass('active-grid-column');
    $("[id*='multicolumn_3tmAAU']").addClass('active-grid-column');  
    $("[id*='multicolumn_qjBmmM']").removeClass('active-grid-column');
  }    
});
//[id*='multicolumn_N4mifK'],[id*='multicolumn_9rLBFU'],[id*='multicolumn_3tmAAU']


 $('.grid-options span').click(function(){
  if($(this).hasClass('grid-option-three')){
    $('.product-grid-container .product-grid').removeClass('product-grid-four');
    $('.product-grid-container .product-grid').addClass('product-grid-three');
  }
  if($(this).hasClass('grid-option-four')){
    $('.product-grid-container .product-grid').addClass('product-grid-four');
    $('.product-grid-container .product-grid').removeClass('product-grid-three');
  }  

 }); 


(function () {
  const PARENT_SEL = '.collection-description-rich-text';
  const CONTAINER_SEL = '.rich-text__text.rte';
  const TOGGLE_CLASS = 'collection-more-toggle';
  const HIDDEN_CLASS = 'hidden-content';

  function initWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.moreInit === '1') return;
    const container = wrapper.querySelector(CONTAINER_SEL);
    if (!container) return;

    wrapper.dataset.moreInit = '1';

    const nodes = Array.from(container.querySelectorAll('p, h2, h3, h4, h5, h6'));
    if (nodes.length === 0) return;

    const firstParagraph = nodes.find(n => n.tagName === 'P');
    if (!firstParagraph) return;

    // find heading before the first paragraph
    let firstHeading = null;
    for (const node of nodes) {
      if (/^H[2-6]$/.test(node.tagName)) {
        if (node.compareDocumentPosition(firstParagraph) & Node.DOCUMENT_POSITION_PRECEDING) {
          firstHeading = node;
        }
        break;
      }
      if (node === firstParagraph) break;
    }

    // create hidden wrapper
    let hiddenWrapper = container.querySelector('.' + HIDDEN_CLASS);
    if (!hiddenWrapper) {
      hiddenWrapper = document.createElement('div');
      hiddenWrapper.className = HIDDEN_CLASS;
      container.appendChild(hiddenWrapper);
    }
    hiddenWrapper.style.display = 'none';

    // move everything except firstParagraph and optional firstHeading
    nodes.forEach(node => {
      if (node === firstParagraph || node === firstHeading) return;
      if (!node.closest('.' + HIDDEN_CLASS)) {
        hiddenWrapper.appendChild(node);
      }
    });

    // add toggle button
    if (container.querySelector('.' + TOGGLE_CLASS)) return;

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = TOGGLE_CLASS;
    toggle.textContent = 'More';

    // place toggle initially after the first paragraph
    firstParagraph.appendChild(document.createTextNode(' '));
    firstParagraph.appendChild(toggle);

    toggle.addEventListener('click', function () {
      if (hiddenWrapper.style.display === 'none') {
        hiddenWrapper.style.display = 'block';
        toggle.textContent = 'Less';
        container.appendChild(toggle); // move button to bottom
      } else {
        hiddenWrapper.style.display = 'none';
        toggle.textContent = 'More';
        firstParagraph.appendChild(document.createTextNode(' '));
        firstParagraph.appendChild(toggle); // move button back up
      }
    });
  }

  document.querySelectorAll(PARENT_SEL).forEach(initWrapper);

  const observer = new MutationObserver(() => {
    document.querySelectorAll(PARENT_SEL).forEach(initWrapper);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(() => observer.disconnect(), 10000);
})();


//BADGE UPDATE
document.addEventListener("DOMContentLoaded", () => {
  const resultsSelector = ".ss__results.grid.product-grid";
  const productCache = new Map();

  async function getProductData(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error("Fetch failed");
      const data = await res.json();
      productCache.set(handle, data);
      return data;
    } catch (err) {
      console.warn("[Monthly Offers] Error fetching product:", handle, err);
      return null;
    }
  }

  async function processCard(card) {
    const linkEl = card.querySelector('a[href*="/products/"]');
    if (!linkEl) return;

    const handle = linkEl
      .getAttribute("href")
      .split("/products/")[1]
      .split("?")[0]
      .replace(/\/$/, "");

    const badgeContainer = card.querySelector(
      ".card__badge.top.right.ss__badge__container"
    );
    if (!badgeContainer) return;

    const product = await getProductData(handle);
    if (!product || !product.tags) return;

    const hasMonthlyOffer = product.tags.includes("Weekly Offer Sale");
    if (!hasMonthlyOffer) return;

    const saleBadge = badgeContainer.querySelector(".badge.ss__badge--sale");
    if (!saleBadge) return;

    // Replace text and classes cleanly
    saleBadge.textContent = "Christmas Offer";
    saleBadge.classList.remove("ss__badge--sale", "color-accent-2");
    saleBadge.classList.add("ss__badge--monthly-offer", "color-accent-1");
  }

  async function updateMonthlyOfferBadges() {
    const cards = document.querySelectorAll(".ss__result");
    if (!cards.length) return;
    await Promise.all([...cards].map(processCard));
  }

  function observeSearchspringResults() {
    const target = document.querySelector(resultsSelector);
    if (!target) {
      setTimeout(observeSearchspringResults, 300);
      return;
    }

    updateMonthlyOfferBadges();

    // React to Searchspring re-renders
    const observer = new MutationObserver(() => {
      clearTimeout(window._monthlyOfferTimer);
      window._monthlyOfferTimer = setTimeout(() => {
        updateMonthlyOfferBadges();
      }, 300);
    });

    observer.observe(target, { childList: true, subtree: true });

    // 🧹 Continuous Cleanup Loop: fix "Monthly OfferSale" if Searchspring re-appends
    setInterval(() => {
      document
        .querySelectorAll(".badge.ss__badge--monthly-offer")
        .forEach((badge) => {
          if (badge.textContent.trim() !== "Christmas Offer") {
            badge.textContent = "Christmas Offer";
          }
        });
    }, 500); // every 0.5s ensures persistent correction
  }

  observeSearchspringResults();
});


document.addEventListener('DOMContentLoaded', () => {
  const mediaList = document.querySelector('.product__media-list');
  const badgeContainer = document.querySelector('.product-badge-container');
  if (!mediaList || !badgeContainer) return;

  // function to sync height
  function syncBadgeHeight() {
    // only on desktop (e.g. >= 750px width)
    if (window.innerWidth < 750) {
      badgeContainer.style.height = '';
      return;
    }

    const mediaHeight = mediaList.offsetHeight;
    badgeContainer.style.height = mediaHeight + 'px';
  }

  // initial sync
  syncBadgeHeight();

  // adjust when window resizes or content (like images) loads
  window.addEventListener('resize', syncBadgeHeight);
  window.addEventListener('load', syncBadgeHeight);

  // watch for changes to product media (e.g. variant change)
  const observer = new MutationObserver(syncBadgeHeight);
  observer.observe(mediaList, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", () => {
  // Event delegation: listen on the document, not the span
  document.addEventListener("click", (e) => {
    const span = e.target.closest(".yotpo-extra-text");
    if (!span) return; // only trigger if click is on a .yotpo-extra-text

    // Optional: visually indicate it's clickable
    span.style.cursor = "pointer";

    // Find Shopify section (partial match on id)
    const target = document.querySelector("[id*='17327492728c15bdd4']");

    if (target) {
      const headerOffset = 100; // adjust if you have a sticky header
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });

      // Optional: flash highlight effect
      target.style.transition = "background-color 0.6s ease";
      target.style.backgroundColor = "#fff8d6";
      setTimeout(() => target.style.backgroundColor = "", 1000);

    } else {
      console.warn("Target section not found in DOM at click time.");
    }
  });
});


setTimeout(function() {
  $('.product__info-wrapper .yotpo-widget-instance').show();
  $('.ss__result__inner .yotpo-widget-instance').show();
  
}, 4000);  



//FURTHER 20% OFF BADGE REMOVE IT ON FRIDAY

function applyFurtherBadges() {
    const items = document.querySelectorAll('.ss__result__image');

    items.forEach(item => {
        const content = item.querySelector('.card__content');
        if (!content) return;

        // prevent duplicates
        if (content.querySelector('.ss__badge--further-badge')) return;

        // get product title
        const titleEl = content.querySelector('.card__heading, .product-title, a[title], h3, h2');
        if (!titleEl) return;

        const title = titleEl.textContent.toLowerCase();

        // exclusions
        const excluded = ["mattress", "base", "bed head", "blanket box","essential merino","fine merino"];
        if (excluded.some(word => title.includes(word))) return;

        // build badge
        const badge = document.createElement('div');
        badge.className = "card__badge bottom right ss__badge__container card-badge-further";
        badge.innerHTML = `
            <span class="badge badge--bottom-right ss__badge--further-badge">
                20% Auto Discount
            </span>
        `;

        // ensure positioning
        content.style.position = "relative";

        content.appendChild(badge);
    });
}

//const observer = new MutationObserver(applyFurtherBadges);
//observer.observe(document.body, { childList: true, subtree: true });

//applyFurtherBadges();



//MERINO UPDATE
function applyMerinoBadges() {   // function name updated earlier
    const items = document.querySelectorAll('.ss__result__image');

    items.forEach(item => {
        const content = item.querySelector('.card__content');
        if (!content) return;

        // prevent duplicates
        if (content.querySelector('.ss__badge--merino-badge')) return; // updated class

        // get product title
        const titleEl = content.querySelector('.card__heading, .product-title, a[title], h3, h2');
        if (!titleEl) return;

        const title = titleEl.textContent.toLowerCase();

        // Only apply badge for these / Exclude if "pack"
        const isEligible = (title.includes("essential merino") || title.includes("fine merino"));
        const isPack = title.includes("pack");
        if (!isEligible || isPack) return;

        // build badge
        const badge = document.createElement('div');
        badge.className = "card__badge bottom right ss__badge__container card-badge-merino";
        badge.innerHTML = `
            <span class="badge badge--bottom-right ss__badge--merino-badge">
                up to 60% Off
            </span>
        `;

        // ensure positioning
        content.style.position = "relative";
        content.appendChild(badge);
    });
}

//const merinoObserver = new MutationObserver(applyMerinoBadges);
//merinoObserver.observe(document.body, { childList: true, subtree: true });

//applyMerinoBadges(); // run initial


//MATTRESSES BADGES
function applyMattressBadges() {
    const items = document.querySelectorAll('.ss__result__image');

    items.forEach(item => {
        const content = item.querySelector('.card__content');
        if (!content) return;

        // Prevent duplicate badge insertion
        if (content.querySelector('.ss__badge--mattress-badge')) return;

        // Grab product title
        const titleEl = content.querySelector('.card__heading, .product-title, a[title], h3, h2');
        if (!titleEl) return;

        const title = titleEl.textContent.toLowerCase();

        // Keywords for this function
        const keywords = ["mattress", "base", "bed head"];
        const matchesKeyword = keywords.some(word => title.includes(word));
        const isPack = title.includes("pack");

        // Only apply if matches AND not a pack
        if (!matchesKeyword || isPack) return;

        // Insert badge
        const badge = document.createElement('div');
        badge.className = "card__badge bottom right ss__badge__container card-badge-mattress";
        badge.innerHTML = `
            <span class="badge badge--bottom-right ss__badge--mattress-badge">
                40% Off
            </span>
        `;

        content.style.position = "relative";
        content.appendChild(badge);
    });
}

// Unique observer to avoid conflicts
const mattressBadgeObserver = new MutationObserver(applyMattressBadges);
mattressBadgeObserver.observe(document.body, { childList: true, subtree: true });

applyMattressBadges(); // initial run
